import React from "react";
import { set, get } from "services/storage";
import md5 from 'crypto-js/md5';
import moment from "moment";
import * as moment_tz from "moment-timezone";
import axios from "axios";
import {get_edulib_catalog, get_catalog_from_koolskools} from "services/api";
import ExcelJS from "exceljs/dist/exceljs";
import saveAs from "file-saver";
import { PDFDocument } from "pdf-lib";
import * as XLSX from "xlsx";
import JSZip from "jszip";

import ib_elyakada_logo from 'assets/img/school/ib_elyakada_logo.png';
import elyakada_logo from 'assets/img/school/elyakada_logo.png';
import backWave1 from "../assets/img/school/backWave1.svg";
import backWave2 from "../assets/img/school/backWave2.svg";
import backWave3 from "../assets/img/school/backWave3.svg";
import backWave4 from "../assets/img/school/backWave4.svg";
import backWave5 from "../assets/img/school/backWave5.svg";
import backWave6 from "../assets/img/school/backWave6.svg";
import backWave7 from "../assets/img/school/backWave7.svg";
import backWave8 from "../assets/img/school/backWave8.svg";
import backWave9 from "../assets/img/school/backWave9.svg";
import backWave10 from "../assets/img/school/backWave10.svg";
import backWave11 from "../assets/img/school/backWave11.svg";
import backWave12 from "../assets/img/school/backWave12.svg";
import backWave13 from "../assets/img/school/backWave13.svg";
import backWave14 from "../assets/img/school/backWave14.svg";
import backWave15 from "../assets/img/school/backWave15.svg";
import backWave16 from "../assets/img/school/backWave16.svg";
import backWave17 from "../assets/img/school/backWave17.svg";
import backWave18 from "../assets/img/school/backWave18.svg";
import backWave19 from "../assets/img/school/backWave19.svg";
import backWave20 from "../assets/img/school/backWave20.svg";
import backWave21 from "../assets/img/school/backWave21.svg";
import backWave22 from "../assets/img/school/backWave22.svg";
import backWave23 from "../assets/img/school/backWave23.svg";
import backWave24 from "../assets/img/school/backWave24.svg";
import { images, images_menu } from "../pages/school/classes/_resources";
import heic2any from "heic2any";
import {upload_asset_s3_api} from 'services/cms/api'
import { parseString } from "xml2js";

const START_RAMADA_STR = "3026-09-19";
// const END_RAMADA_STR = "2026-03-21";

export const colors = [
  {start: '#86e9e2', end:'#83dad3', icon: backWave1},
  {start: '#f9e887', end:'#f0d26f', icon: backWave2},
  {start: '#bca7f7', end:'#9e82ee', icon: backWave3},
  {start: '#b7d8ff', end:'#87bae6', icon: backWave4}
]
export const classes_colors = [
  { start: '#86e9e2', end:'#83dad3', icon: backWave1 }, // turquoise clair
  { start: '#f28b82', end:'#e57373', icon: backWave5 }, // rouge corail
  { start: '#f9e887', end:'#f0d26f', icon: backWave2 }, // jaune
  { start: '#6a5acd', end:'#7a5cff', icon: backWave6 }, // indigo
  { start: '#bca7f7', end:'#9e82ee', icon: backWave3 }, // violet clair
  { start: '#00c853', end:'#00e676', icon: backWave7 }, // vert
  { start: '#b7d8ff', end:'#87bae6', icon: backWave4 }, // bleu clair
  { start: '#ff7043', end:'#ff5722', icon: backWave8 }, // orange
  { start: '#d81b60', end:'#f06292', icon: backWave9 }, // rose vif
  { start: '#26c6da', end:'#00acc1', icon: backWave10 }, // cyan
  { start: '#ffd54f', end:'#ffb300', icon: backWave11 }, // or
  { start: '#8e24aa', end:'#ab47bc', icon: backWave12 }, // violet profond
  { start: '#43a047', end:'#66bb6a', icon: backWave13 }, // vert forêt
  { start: '#1976d2', end:'#1e88e5', icon: backWave14 }, // bleu royal
  { start: '#f4511e', end:'#e64a19', icon: backWave15 }, // rouge-orangé
  { start: '#c2185b', end:'#d81b60', icon: backWave16 }, // framboise
  { start: '#009688', end:'#26a69a', icon: backWave17 }, // teal
  { start: '#ffca28', end:'#ffb300', icon: backWave18 }, // jaune profond
  { start: '#673ab7', end:'#5e35b1', icon: backWave19 }, // violet foncé
  { start: '#2e7d32', end:'#388e3c', icon: backWave20 }, // vert foncé
  { start: '#0288d1', end:'#039be5', icon: backWave21 }, // bleu ciel foncé
  { start: '#ef6c00', end:'#f57c00', icon: backWave22 }, // orange foncé
  { start: '#ad1457', end:'#c2185b', icon: backWave23 }, // magenta foncé
  { start: '#00796b', end:'#00897b', icon: backWave24 }  // vert canard
]

var create_kne_key = () => {
  var ky = "*56Koolskools824R" + moment().format("DDMMYYYY");
  var res = md5(ky);;
  return res.toString();
}
export function assign_value(o){
    var r = {};
    Object.keys(o).forEach(function (k) {
        r[k] = o[k];
    });
    return r;
} 

export const groupBy = (key,array, case_sensive) =>
  array.reduce(
    (objectsByKeyValue, obj) => ({
      ...objectsByKeyValue,
      [case_sensive?obj[key].toLowerCase():obj[key]]: (objectsByKeyValue[case_sensive?obj[key].toLowerCase():obj[key]] || []).concat(obj)
    }),
    {}
);

export const groupBy2 = (array, callback) => {
  return array.reduce(function(store, item) {
    var key = callback(item);
    var value = store[key] || [];
    store[key] = value.concat([item]);
    return store;
  }, {})
}
export const get_sanadi_competencies_periods = (new_format) => {
if(new_format){
    return [
      {name: "DIAGNOSTIQUE", id: 0},
      {name: "E1", id: 1},
    ];
  }
  return [
    {name: "Baseline", id: 0},
    {name: "Midline", id: 1},
    {name: "Endline", id: 2},
  ];
}
export const get_sanadi_periods_names = () => {
  return [
    {name: "DIAGNOSTIQUE", id: "DIAGNOSTIQUE"},
    {name: "E1", id: "E1"},
    {name: "E2", id: "E2"},
    {name: "E3", id: "E3"},
    // {name: "E4", id: "E4"},
  ];
}
export const get_sanady_notes_periods = () => {
  return [
    {name: "E2", id: 2},
    {name: "E3", id: 3},
    // {name: "E4", id: 4},
  ];
}
export const remove_number_in_parentheses = (filename) => {
  // Using a regular expression to search for the number within parentheses
  const pattern = /\(\d+\)$/; // Search for a number within parentheses at the end of the filename
  // Get the extension by finding the last occurrence of '.' and extracting the substring from that point
  const extensionIndex = filename.lastIndexOf('.');
  const baseName = filename.substring(0, extensionIndex);
  const extension = filename.substring(extensionIndex);
  const match = baseName.match(pattern);
  let resName = baseName;
  if (match) {
      // If a number within parentheses is found, remove it from the filename
      const originalName = baseName.substring(0, match.index);
      resName = originalName;
  }
  return resName.trim() + extension;
}

export const capitalizeEveryWord = (phrase) => {
  return phrase.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

export const numberToWordsFrench = (number, unit1, unit2) => {
  const units = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  const teens = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
  const tens = ['', 'dix', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];

  function convertBelowHundred(n) {
    if (n < 10) return units[n];
    if (n >= 10 && n < 20) return teens[n - 10];
    
    const digit = n % 10;
    const ten = Math.floor(n / 10);
    
    if (ten === 7) {
      // 70-79: soixante + 10-19
      if (digit === 1) return 'soixante et onze';
      return digit === 0 ? 'soixante-dix' : `soixante-${teens[digit]}`;
    }
    
    if (ten === 9) {
      // 90-99: quatre-vingt + 10-19
      return digit === 0 ? 'quatre-vingt-dix' : `quatre-vingt-${teens[digit]}`;
    }
    
    if (ten === 8) {
      // 80-89: quatre-vingt(s) + units
      if (digit === 0) return 'quatre-vingts';
      return `quatre-vingt-${units[digit]}`;
    }

    // 21, 31, 41, 51, 61 use "et un"
    if (digit === 1 && ten > 1) {
      return `${tens[ten]} et un`;
    }
    
    // Regular tens (0-69)
    if (digit === 0) return tens[ten];
    if (ten === 1) return `${tens[ten]} et ${units[digit]}`;
    return `${tens[ten]}-${units[digit]}`;
  }

  function convertBelowThousand(n) {
    if (n === 0) return '';
    
    const hundred = Math.floor(n / 100);
    const belowHundred = n % 100;
    const belowHundredText = convertBelowHundred(belowHundred);
    
    let result = '';
    if (hundred > 0) {
      if (hundred === 1) {
        result += 'cent';
      } else {
        result += units[hundred] + ' cent';
      }
      // Add 's' to 'cent' only if it's a multiple of 100
      if (hundred > 1 && belowHundred === 0) {
        result += 's';
      }
    }
    
    if (belowHundredText) {
      result += (result ? ' ' : '') + belowHundredText;
    }
    
    return result;
  }

  // Handle both integer and decimal numbers
  const numberStr = String(number);
  const parts = numberStr.split(/[.,]/);
  const integerPart = parseInt(parts[0], 10);
  const decimalPart = parts[1];

  if (integerPart === 0 && !decimalPart) {
    return 'zéro' + (unit1 || '');
  }

  const billion = Math.floor(integerPart / 1000000000);
  const million = Math.floor((integerPart % 1000000000) / 1000000);
  const thousand = Math.floor((integerPart % 1000000) / 1000);
  const remainder = integerPart % 1000;

  let result = '';
  
  if (billion > 0) {
    const billionText = billion === 1 ? 'un' : convertBelowThousand(billion);
    result += billionText + (billion === 1 ? ' milliard' : ' milliards');
  }
  
  if (million > 0) {
    if (result) result += ' ';
    const millionText = million === 1 ? 'un' : convertBelowThousand(million);
    result += millionText + (million === 1 ? ' million' : ' millions');
  }
  
  if (thousand > 0) {
    if (result) result += ' ';
    if (thousand === 1) {
      result += 'mille';
    } else {
      result += convertBelowThousand(thousand) + ' mille';
    }
  }
  
  if (remainder > 0) {
    if (result) result += ' ';
    result += convertBelowThousand(remainder);
  }

  // Handle decimal part
  if (decimalPart) {
    try{
      result = (result || 'zéro') + (unit1 || '');
      result += ' et ';
      let num_decimal = parseInt(decimalPart);
      if(!isNaN(num_decimal)){
        if(num_decimal > 99){
          num_decimal = Math.round(num_decimal / Math.pow(10, decimalPart.length - 2));
        }
        else if(num_decimal < 10 && decimalPart.length == 1){
          num_decimal = num_decimal * 10;
        }
        let decimalText = convertBelowHundred(num_decimal);
        result += decimalText + (unit2 || '');
      }
      else{

      }
    }
    catch(err){
      result = result.trim() + (unit1 || '');
    }
  }
  else{
    result = result.trim() + (unit1 || '')
  }

  return result;
}

export const calc_avg_subject = (subject_data) => {
  return [8, 2]
}
export const calc_avg_subject2 = (subject_data, details_by_controls, no_chapters, group_subjects, subjects_groups, get_nbr_chapters_noted, subject_coefficient_) => {
  subject_data = subject_data || {};
  details_by_controls = details_by_controls || false;
  no_chapters = no_chapters || false;
  group_subjects = group_subjects || false;
  subjects_groups = subjects_groups || {};
  get_nbr_chapters_noted = get_nbr_chapters_noted || false;
  subject_coefficient_ = subject_coefficient_ || 0;
  let sum_champers_notes = 0;
  let sum_coefficients = 0;
  let res = 0;
  if(!no_chapters){
    Object.keys(subject_data["chapters"] || {}).map(chapter_id => {
      let chapter_data = subject_data["chapters"][chapter_id];
      if(!chapter_id){
        if(details_by_controls){
            let sum_chapter_note = 0;
            let sum_controls_coefficients = 0;
            Object.keys(chapter_data["controls"] || {}).map(control_id => {
              let control_data = chapter_data["controls"][control_id];
              sum_controls_coefficients += (control_data['note'] || 0) ? (control_data['coefficient'] || 0) : 0;
              sum_chapter_note += parseFloat(control_data['note'] || 0) * parseFloat(control_data['coefficient'] || 0);
            });
            let note_ = (sum_chapter_note / parseFloat(sum_controls_coefficients || 1));
            sum_champers_notes = note_;
            sum_coefficients += note_ ? 1 : 0;
        }
        else{
            sum_champers_notes += chapter_data["note"] || 0;
            sum_coefficients += chapter_data["note"] || 0 ? 1 : 0;
        }
      }
      else if(chapter_data["coefficient"] || 0){
        let chapter_note = 0;
        if(details_by_controls){
          let sum_chapter_note = 0
          let sum_controls_coefficients = 0
          Object.keys(chapter_data["controls"] || {}).map(control_id => {
            let control_data = chapter_data["controls"][control_id];
            sum_controls_coefficients += (control_data['note'] || 0) ? (control_data['coefficient'] || 0) : 0;
            sum_chapter_note += parseFloat(control_data['note'] || 0) * parseFloat(control_data['coefficient'] || 0);
          });
          chapter_note = (sum_chapter_note / parseFloat(sum_controls_coefficients || 1)) * (chapter_data["coefficient"] || 0);
        }
        else{
          chapter_note = (chapter_data["note"] || 0) * (chapter_data["coefficient"] || 0);
        }
        sum_champers_notes += chapter_note;
        sum_coefficients += chapter_note ? (chapter_data["coefficient"] || 0) : 0;
      }
      if(get_nbr_chapters_noted){
        res = [Math.round(sum_champers_notes / (sum_coefficients || 1), 2), sum_coefficients];
      }
      else{
        res = Math.round(sum_champers_notes / (sum_coefficients || 1), 2);
      }
    })
  }
  else{
    let sum_chapter_note = 0
    let sum_coefficients = 0
    Object.keys(subject_data["controls"] || {}).map(control_id => {
      let control_data = subject_data["controls"][control_id];
      sum_coefficients += control_data['coefficient'] || 0;
      sum_chapter_note += (control_data['coefficient'] || 0) * (control_data['note'] || 0);
    });
    if(sum_coefficients == 0){
      if(get_nbr_chapters_noted){
        res = [Math.round(subject_data["avg"] || 0, 2), (sum_coefficients || subject_coefficient_)];
      }
      res = Math.round(subject_data["avg"] || 0, 2);
    }
    else{
      let subject_note = sum_chapter_note / (sum_coefficients || 1);
      if(get_nbr_chapters_noted){
        res = [Math.round(subject_note, 2), sum_coefficients]
      }
      else{
        res = Math.round(subject_note, 2);
      }
    }
  }
  return res;
}

export const render_sanady_competency_note = (note) => {
  if(note && note > 0 || note === 0){
    if(note <= 2){
      return "NA";
    }
    else if(2 < note && note < 8){
      return "EA";
    }
    else if(note <= 10){
      return "A";
    }
  }
  return "";
}
  

export const convert_heic_to_jpeg = (heic_url, callback) => {
  fetch(heic_url)
  .then((res) => res.blob())
  .then((blob) => {
    heic2any({
        blob,
        toType: "image/jpeg",
        quality: 1, // cuts the quality and size by half
    })
    .then((conversionResult) => {
      var filename= heic_url.split('\\').pop().split('/').pop();
      filename = filename.replaceAll(".heic", ".jpeg").replaceAll(".HEIC", ".JPEG")
      var file = new File([conversionResult], filename);
      let formData = new FormData();
      formData.append("file", file, (new Date()).getTime() + '_' + filename);
      upload_asset_s3_api(formData).then(res => {
        callback(res.url);
      }).catch(error => console.log("error", error));
        // conversionResult is a BLOB
        // of the JPEG formatted image
        // with low quality
    })
  })
  .catch((e) => {
    // see error handling section
  });
}

export const animateCSS = (node, animation, time = '0.05s', prefix = '') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    // const node = document.querySelector(element);
    
    node.classList.add(`${prefix}animated`, animationName);
    node.style.setProperty('--animate-duration', time);
    node.addEventListener('animationend', handleAnimationEnd, {once: true});
      

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    }
    node.addEventListener('animationend', handleAnimationEnd, {once: true});
    
  });
export const numStr = (a, b, replace_with)  => {
  // return a;
  if(replace_with !== undefined){
    return parseFloat(a).toLocaleString('en', {minimumFractionDigits: (b?b:0)}).replaceAll(',', replace_with)
  }

  return parseFloat(a).toLocaleString('en', {minimumFractionDigits: (b?b:0)}).replaceAll(',', ' ')
  // a = '' + a;
  // b = b || ' ';
  // var c = '',
  //     d = 0;
  // while (a.match(/^0[0-9]/)) {
  //     a = a.substr(1);
  // }
  // for (var i = a.length-1; i >= 0; i--) {
  //     c = (d != 0 && d % 3 == 0) ? a[i] + b + c : a[i] + c;
  //     d++;
  // }
  // return c;
}

export const getFlooredFixed = (v, d) => {
  return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
}

export const checkIfConflict = (start_abs, end_abs, start_vac, end_vac) => {
  // console.log(start_abs.isSameOrBefore(start_vac, 'day'))
  // console.log(end_abs.isSameOrAfter(start_vac, 'day'))
  // console.log(start_abs.isSameOrBefore(end_vac, 'day'))
  // console.log(end_abs.isSameOrAfter(end_vac, 'day'))

  // console.log(start_vac.isSameOrBefore(start_abs, 'day'))
  // console.log(end_vac.isSameOrAfter(start_abs, 'day'))
  // console.log(start_vac.isSameOrBefore(end_abs, 'day'))
  // console.log(end_vac.isSameOrAfter(end_abs, 'day'))
  return (start_abs.isSameOrBefore(start_vac, 'day') && end_abs.isSameOrAfter(start_vac, 'day')) || (start_abs.isSameOrBefore(end_vac, 'day') && end_abs.isSameOrAfter(end_vac, 'day')) || 
  (start_vac.isSameOrBefore(start_abs, 'day') && end_vac.isSameOrAfter(start_abs, 'day')) || (start_vac.isSameOrBefore(end_abs, 'day') && end_vac.isSameOrAfter(end_abs, 'day'));
}

const cycles_names = {
  "chapter": ["Chapter", "Module"],
  "lesson": ["Lesson", "Unit"],
  "competency": ["Competency", "Learning outcome"],
  "competencies": ["Competencies", "Learning outcomes"],
  "std_txtbook": ["Textbook", "Work to do "],
  "txtbook": ["Textbook", "Work to do"],
  "notebook_journal": ["Notebook journal", "Cahier de texte enseignant"],
}

export const get_white_exams_types = () => {
  return [
    {
      key: "paper_1", label: "Paper 1",
    },
    {
      key: "paper_2", label: "Paper 2",
    },
    {
      key: "paper_3", label: "Paper 3",
    },
  ]
}
export const get_status_sanady = () => {
  return [
    {
      key: "B", label: "Bénéficiaire",
    },
    {
      key: "NB", label: "Non bénéficiaire",
    },
    {
      key: "NE", label: "Non éligible",
    },
    // {
    //   key: "AB", label: "Abandon",
    // },
  ]
}

export const getCycleName = (key, level, is_student, get_boolean) => {
  var school = get("school");
  var levels = get("levels");
  if(!levels || levels.length == 0){
    levels = get("all_levels") || [];
  }
  var levels_groups = level || is_student ? get("level_groups") || [] : (school ? school.levels_groups : get("professor_levels_groups")) || [];
  if(!levels_groups || levels_groups.length == 0){
    levels_groups = get("professor_levels_groups") || [];
  }
  var is_primary = true;
  if(level){
    if(!level.level_id){
      level = levels.filter(l => l.level_id == level)[0];
    }
    else{
      level = levels.filter(l => l.level_id == level.level_id)[0];
    }
    var level_group = levels_groups.filter(l_g => l_g.id == (level && level.group_id))[0];
    is_primary = level_group ? level_group.num < 2 : true;
  }
  else{
    is_primary = levels_groups.filter(l_g => l_g.num > 1).length == 0;
  }
  if(get_boolean){
    return is_primary;
  }
  return (cycles_names[key] || ["", ""])[is_primary ? 0 : 1]
}
export const get_sanady_period = (sanady_period, short_name) => {
  if(sanady_period == 2){
    return short_name ? "E" : "Endline";
  }
  else if(sanady_period == 1){
    return short_name ? "M" : "Midline";
  }
  return short_name ? "B" : "Baseline";
}
export const organize_programs_projects_schools = (programs_projects_schools, as_projects, get_programs_with_students) => {
  if(as_projects){
    let projects = [];
    let programs_ = [];
    let programs_keys = Object.keys(programs_projects_schools);
    programs_keys.filter(key => key != "programs").map(pk => {
      let program = programs_projects_schools[pk];
      programs_.push(program);
      projects = projects.concat(Object.keys(program.projects).map(k_ => program.projects[k_]));
    });
    programs_.sort((p1, p2) => p1.name >= p2.name ? 1 : -1);
    projects.sort((p1, p2) => p1.name >= p2.name ? 1 : -1);
    return get_programs_with_students ? [projects, programs_] : projects;
  }
  if(!programs_projects_schools.programs || programs_projects_schools.programs.length == 0){
    let programs = [];
    let programs_keys = Object.keys(programs_projects_schools);
    programs_keys.filter(key => key != "programs").map(pk => {
      let program = programs_projects_schools[pk];
      programs.push(program);
    });
    programs.sort((p1, p2) => p1.name >= p2.name ? 1 : -1);
    programs_projects_schools.programs = programs;
  }
  return programs_projects_schools;
}
export const get_projects_from_pogram = (program, get_all_projects, programs_projects, programs_ids, regions_ids) => {
  var projects_res = []
  if(programs_ids){
    let projects = [];
    let programs_keys = programs_ids;
    programs_keys.map(pk_ => {
      let program = programs_projects[pk_];
      let projects_keys = Object.keys(program.projects || {});
      projects_keys.map(pk => {
        let project = program.projects[pk];
        project.program = program;
        projects.push(project);
      });
    });
    projects_res = projects;
  }
  else if(get_all_projects || program === true){
    let projects = [];
    let programs_keys = Object.keys(programs_projects || {});
    programs_keys.map(pk_ => {
      let program = programs_projects[pk_];
      let projects_keys = Object.keys(program.projects || {});
      projects_keys.map(pk => {
        let project = program.projects[pk];
        project.program = program;
        projects.push(project);
      });
    });
    projects_res = projects;
  }
  else if(!program){
    projects_res = [];
  }
  else{
    let projects = [];
    let projects_keys = Object.keys(program.projects || {});
    projects_keys.map(pk => {
      let project = program.projects[pk];
      project.program = program;
      projects.push(project);
    });
    projects.sort((p1, p2) => p1.name >= p2.name ? 1 : -1);
    projects_res = projects;
  }
  if(regions_ids){
    projects_res = projects_res.filter(pr => regions_ids.indexOf(pr.project_region_id) != -1);
  }
  return projects_res;
}
export const get_schools_from_projects = (projects, as_dict) => {

  if(!projects){
    return as_dict ? {} : [];
  }
  if(as_dict){

    let schools = {};
    projects.map(project => {
      project.schools.map(school => {
        schools[school.id] = school;
      });
    });
    return schools;
  }
  let schools = [];
  projects.map(project => {
    schools = schools.concat(project.schools);
  });
  schools.sort((p1, p2) => p1.name >= p2.name ? 1 : -1);
  return schools;
}

export const  areArraysNotEqual = (arr1, arr2) => {
  // Check if both are null or undefined
  var result = false;
  if ((arr1 === null && arr2 === null) || (arr1 === undefined && arr2 === undefined)) {
    result = false;
  }

  // Check if both arrays have the same length
  if (!result && arr1.length !== arr2.length) {
    result = true;
  }

  // Check if all elements are the same
  if(!result){
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          result = true;
        }
    }
  }

  return result;
}

export const check_email_valid = (email) => {
  if(email && email.indexOf("@") >= 0 && email.indexOf(".") >= 0 && email.indexOf(" ") == -1 && email.indexOf("@koolskools.com") == -1){
    if(!window.allow_yop_mails && email.indexOf("@yopmail.com") >= 0){
      return false;
    }
    return true;
  }
  return false;
}

export const  areSetsNotEqual = (set1, set2) => {
  // Check if both are null or undefined
  var are_equal = true;
  if (set1.size !== set2.size){
    are_equal = false;
  }
  else{
    for (let item of set1) {
      if (!set2.has(item)) {
        are_equal = false;
      }
    }

  }
  return !are_equal;
}

export const  init_controls_notes_slices = () => {
  let controls_notes_slices_order = ["skills_proficiency", "good", "intermediate", "delay", "delay_plus"];
  let controls_notes_slices = {
    delay_plus: {
      name: "Retard +",
      levels_groups_num: {
        "0": {min: 0, max: 2.99, },
        "1": {min: 0, max: 2.99, },
        "2": {min: 0, max: 5.99, },
        "3": {min: 0, max: 5.99, },
        "4": {min: 0, max: 2.99, },
        "5": {min: 0, max: 2.99, },
      }
    },
    delay: {
      name: "Retard",
      levels_groups_num: {
        "0": {min: 3, max: 4.99, },
        "1": {min: 3, max: 4.99, },
        "2": {min: 6, max: 9.99, },
        "3": {min: 6, max: 9.99, },
        "4": {min: 3, max: 4.99, },
        "5": {min: 3, max: 4.99, },
      }
    },
    intermediate: {
      name: "Intermédiaire",
      levels_groups_num: {
        "0": {min: 5, max: 7.99, },
        "1": {min: 5, max: 7.99, },
        "2": {min: 10, max: 15.99, },
        "3": {min: 10, max: 15.99, },
        "4": {min: 5, max: 7.99, },
        "5": {min: 5, max: 7.99, },
      }
    },
    good: {
      name: "Bon",
      levels_groups_num: {
        "0": {min: 8, max: 9.99, },
        "1": {min: 8, max: 9.99, },
        "2": {min: 16, max: 18.99, },
        "3": {min: 16, max: 18.99, },
        "4": {min: 8, max: 9.99, },
        "5": {min: 8, max: 9.99, },
      }
    },
    skills_proficiency: {
      name: "Maîtrise des compétences",
      levels_groups_num: {
        "0": {min: 10, max: 10, },
        "1": {min: 10, max: 10, },
        "2": {min: 19, max: 20, },
        "3": {min: 19, max: 20, },
        "4": {min: 10, max: 10, },
        "5": {min: 10, max: 10, },
      }
    },
  };
  return [controls_notes_slices, controls_notes_slices_order];
  
}

export const get_slice_key_from_control_note = (ctrl, level_group_num, controls_notes_slices_params, controls_notes_slices_order) => {
  let slice_key = null;
  controls_notes_slices_order.map(s_key => {
    let slice = controls_notes_slices_params[s_key];
    let level_group_slice = slice.levels_groups_num[level_group_num];
    if(level_group_slice && ctrl.note >= level_group_slice.min && ctrl.note <= level_group_slice.max){
      slice_key = s_key;
    }
  });
  return slice_key;
}
export const get_slice_key_min_max_note = (level_group_num, controls_notes_slices_params, controls_notes_slices_order) => {
  let slice_min_max_note = "--";
  controls_notes_slices_order.map(s_key => {
    let slice = controls_notes_slices_params[s_key];
    let level_group_slice = slice.levels_groups_num[level_group_num];
    if(level_group_slice){
      slice_min_max_note = level_group_slice.min + " - " + level_group_slice.max;
    }
  });
  return slice_min_max_note;
}

export const sortByAttrWithEmptyLast = (arr, attr, reporting_categories, section_name) => {
  return arr.sort((a, b) => {
    let va = reporting_categories ? reporting_categories[a[attr]] : a[attr];
    let vb = reporting_categories ? reporting_categories[b[attr]] : b[attr];

    if(section_name == "reporting_students"){
      if(va && a[attr] == "students_lists"){
        va = "1_" + va;
      }
      else if(va && a[attr] == "students_effectifs"){
        va = "2_" + va;
      }
      else if(va && a[attr] == "inscriptions_and_departure"){
        va = "3_" + va;
      }
      else if(va && a[attr] == "students_monitoring"){
        va = "4_" + va;
      }
      if(vb && b[attr] == "students_lists"){
        vb = "1_" + vb;
      }
      else if(vb && b[attr] == "students_effectifs"){
        vb = "2_" + vb;
      }
      else if(vb && b[attr] == "inscriptions_and_departure"){
        vb = "3_" + vb;
      }
      else if(vb && b[attr] == "students_monitoring"){
        vb = "4_" + vb;
      }
    }
    else if(section_name == "reporting_professors"){
      if(va && a[attr] == "professors_lists"){
        va = "1_" + va;
      }
      else if(va && a[attr] == "professors_absences"){
        va = "2_" + va;
      }
      else if(va && a[attr] == "professors_volumes"){
        va = "3_" + va;
      }
      else if(va && a[attr] == "professors_remplacements"){
        va = "4_" + va;
      }
      else if(va && a[attr] == "professors_statistics"){
        va = "5_" + va;
      }
      if(vb && b[attr] == "professors_lists"){
        vb = "1_" + vb;
      }
      else if(vb && b[attr] == "professors_absences"){
        vb = "2_" + vb;
      }
      else if(vb && b[attr] == "professors_volumes"){
        vb = "3_" + vb;
      }
      else if(vb && b[attr] == "professors_remplacements"){
        vb = "4_" + vb;
      }
      else if(vb && b[attr] == "professors_statistics"){
        vb = "5_" + vb;
      }
    }
    else if(section_name == "reporting_evaluations"){
      if(va && a[attr] == "devoirs_category"){
        va = "1_" + va;
      }
      else if(va && a[attr] == "notes_category"){
        va = "2_" + va;
      }
      else if(va && a[attr] == "competencies_category"){
        va = "3_" + va;
      }
      else if(va && a[attr] == "aquis_category"){
        va = "4_" + va;
      }
      if(vb && b[attr] == "devoirs_category"){
        vb = "1_" + vb;
      }
      else if(vb && b[attr] == "notes_category"){
        vb = "2_" + vb;
      }
      else if(vb && b[attr] == "competencies_category"){
        vb = "3_" + vb;
      }
      else if(vb && b[attr] == "aquis_category"){
        vb = "4_" + vb;
      }
    }
    else if(section_name == "reporting_payments"){
      if(va && a[attr] == "bordereau_and_bank_transcript_category"){
        va = "1_" + va;
      }
      else if(va && a[attr] == "payments_journals_category"){
        va = "2_" + va;
      }
      else if(va && a[attr] == "impayed_category"){
        va = "3_" + va;
      }
      else if(va && a[attr] == "remises_category"){
        va = "4_" + va;
      }
      else if(va && a[attr] == "ca_and_encaissements_category"){
        va = "5_" + va;
      }
      else if(va && a[attr] == "services_category"){
        va = "6_" + va;
      }
      else if(va && a[attr] == "report_comptables_category"){
        va = "7_" + va;
      }
      else if(va && a[attr] == "financial_simulations_category"){
        va = "8_" + va;
      }
      else if(va && a[attr] == "other_category"){
        va = "9_" + va;
      }

      if(vb && b[attr] == "bordereau_and_bank_transcript_category"){
        vb = "1_" + vb;
      }
      else if(vb && b[attr] == "payments_journals_category"){
        vb = "2_" + vb;
      }
      else if(vb && b[attr] == "impayed_category"){
        vb = "3_" + vb;
      }
      else if(vb && b[attr] == "remises_category"){
        vb = "4_" + vb;
      }
      else if(vb && b[attr] == "ca_and_encaissements_category"){
        vb = "5_" + vb;
      }
      else if(vb && b[attr] == "services_category"){
        vb = "6_" + vb;
      }
      else if(vb && b[attr] == "report_comptables_category"){
        vb = "7_" + vb;
      }
      else if(vb && b[attr] == "financial_simulations_category"){
        vb = "8_" + vb;
      }
      else if(vb && b[attr] == "other_category"){
        vb = "9_" + vb;
      }
    }

    const aEmpty = va === undefined || va === null || va === "";
    const bEmpty = vb === undefined || vb === null || vb === "";

    // both empty → equal
    if (aEmpty && bEmpty) return 0;

    // only a empty → a goes last
    if (aEmpty) return 1;

    // only b empty → b goes last
    if (bEmpty) return -1;

    // normal comparison
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  });
}

const get_grade_threshold_color = (note, grade_thresholds) => {
  if(!note && note !== 0){
    return "#ffffff"
  }
  let grade_thresholds_ = (grade_thresholds || []).filter(g_t => g_t['min_grade'] <= note && note <= g_t['max_grade']);
  if(grade_thresholds_[0]){
    let col = grade_thresholds_[0]["color"];
    col = col != "transparent" ? col : "#ffffff";
    return col;
  }
  return "#ffffff"
}

export const installMetaPixel = (meta_pixel_id) => {
  if (window.fbq && window.last_meta_pixel_id === meta_pixel_id) return;

  (function(f,b,e,v,n,t,s)
    {
      if(f.fbq)return;
      n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)})(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', meta_pixel_id);
    window.fbq('track', 'PageView');

  window.last_meta_pixel_id = meta_pixel_id;
}

export const installGoogleTag = (google_tag_id, is_thinking_page) => {
  if (!google_tag_id) return;
  if (window.last_google_tag_id === google_tag_id + (is_thinking_page ? "_thinking" : "")) return;

  window.dataLayer = window.dataLayer || [];

  if (!window.gtag) {
    window.gtag = function(){window.dataLayer.push(arguments);};
    window.gtag('js', new Date());
  }

  const script_id = 'google-gtag-script';
  const script_src = 'https://www.googletagmanager.com/gtag/js?id=' + google_tag_id;
  let script = document.getElementById(script_id);

  if (!script) {
    script = document.createElement('script');
    script.id = script_id;
    script.async = true;
    script.src = script_src;
    document.head.appendChild(script);
  } else if (script.src !== script_src) {
    script.src = script_src;
  }

  if(is_thinking_page){
    window.gtag('event', "conversion", {'send_to': google_tag_id + "/h1abCLno1LsZEOmd0fA9", 'value': 1.0, 'currency': 'MAD'});
  }
  else{
    window.gtag('config', google_tag_id);
  }
  window.last_google_tag_id = google_tag_id + (is_thinking_page ? "_thinking" : "");
}

export const installMicrosoftClarity = (clarity_project_id) => {
  if (!clarity_project_id) return;

  if (window.last_clarity_project_id === clarity_project_id) return;

  const scriptId = "microsoft-clarity-script";
  const scriptSrc = `https://www.clarity.ms/tag/${clarity_project_id}`;

  // Create the global clarity function if it doesn't exist
  if (!window.clarity) {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  }

  let script = document.getElementById(scriptId);

  if (!script) {
    script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
  } else if (script.src !== scriptSrc) {
    script.src = scriptSrc;
  }

  window.last_clarity_project_id = clarity_project_id;
};

export const get_texts_font_size_labels = () => {
  return {
    keys: ["header", "table_header", "subjects", "chapters", "notes", "appreciations"],
    labels: {
      "header": "Entête",
      "table_header": "Entête du tableau",
      "subjects": "Noms des matières",
      "chapters": "Noms des chapitres",
      "notes": "Notes",
      "appreciations": "Appréciations",
    },
  }
}

export const handleExportTRN = (state, levels_ids, student_cols_to_show_, spacer_showed, totals_stats, order_sign, ordered_ids_students, group_subjects, _note, _color, _note_anglo, i, jj, start_column, subjects_headers, index_, show_general_avg, ordered_students_ids, order_by_sign, order_by_key, items_c_avg_list, items_list, subjects_headers2, subjects_headers_orders, subjects_merge_column, level_group, hight_school, show_avg, students_cols_to_show, show_exam_notes, chapters_merge_column, levels_list, is_lycee, multi_levels, selected_semester_obj, students_ids_to_hide, notes_percents_tresholds, notes_columns_avg, not_noted_items) => {
  try {
    let tablea_recap_des_notes = new ExcelJS.Workbook();
    var worksheet = tablea_recap_des_notes.addWorksheet('Tableau recap des notes'),
      header_row_idx = 7,
      headerStyle = { 
        font:{bold: true},
        border: {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        },
        fill :{
          type: 'pattern',
          pattern:'solid',
          fgColor: {
            argb: 'FF8EA9DB'
          }
        },
        alignment:{vertical: 'middle', horizontal: 'center'}
      },
      contentStyle = { 
        border: {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        },
        alignment:{vertical: 'middle', horizontal: 'center'}
      };

    // Title
    worksheet.getRow(2).getCell(5).value = 'Tableau récapitulatif des notes';
    worksheet.getRow(2).getCell(5).style = { 
      font:{bold: true, size: 16},
      border: {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      },
      fill :{
        type: 'pattern',
        pattern:'solid',
        fgColor: {
          argb: 'FF8EA9DB'
        }
      },
      alignment:{vertical: 'middle', horizontal: 'center'}
    };
    worksheet.mergeCells(2, 5, 3, 6);

    // Get state variables
    const details_by_chapters = state.details_by_chapters;
    const details_by_controls = state.details_by_controls;
    const show_appreciations = state.show_appreciations;
    const users_global_notes_by_classes = state.users_global_notes_by_classes || {};
    const users_global_notes_by_classes_sem1 = state.users_global_notes_by_classes_sem1 || {};
    const grade_thresholds = state.grade_thresholds || [];

    // Build header rows
    let header_row = worksheet.getRow(header_row_idx);
    let header_row2 = worksheet.getRow(header_row_idx + 1);
    let header_row3 = worksheet.getRow(header_row_idx + 2);
    
    let col = 1;
    
    // N.O column
    header_row.getCell(col).value = 'N.O';
    header_row.getCell(col).style = headerStyle;
    worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
    col++;
    
    // Name column
    header_row.getCell(col).value = 'Nom et Prénom';
    header_row.getCell(col).style = headerStyle;
    worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
    col++;
    
    // Birthday column
    header_row.getCell(col).value = 'Date de naissance';
    header_row.getCell(col).style = headerStyle;
    worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
    col++;
    
    // Class column
    header_row.getCell(col).value = 'Classe';
    header_row.getCell(col).style = headerStyle;
    worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
    col++;

    let start_data_col = col;

    // Handle different table structures based on hight_school
    if (!hight_school) {
      // Primary/Middle school structure with chapters and controls
      
      // Average columns
      if (show_avg) {
        if (show_general_avg) {
          header_row.getCell(col).value = 'Moyenne S1';
          header_row.getCell(col).style = headerStyle;
          worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
          col++;
        }

        header_row.getCell(col).value = show_general_avg ? 'Moyenne S2' : 'Moyenne S1';
        header_row.getCell(col).style = headerStyle;
        worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
        col++;

        if (show_general_avg) {
          header_row.getCell(col).value = 'Moyenne générale';
          header_row.getCell(col).style = headerStyle;
          worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
          col++;
        }
      }

      // Subject headers with chapters and controls
      if (subjects_headers_orders && subjects_headers) {
        subjects_headers_orders.forEach(subject_id => {
          let subject_header = subjects_headers[subject_id];
          if (!subject_header) return;

          if (details_by_chapters && details_by_controls) {
            // Both chapters and controls
            let total_controls = (subject_header.chapters_orders || []).reduce((sum, ch_id) => {
              return sum + ((subject_header.chapters[ch_id] || {}).controls_orders || []).length;
            }, 0);
            let colspan = total_controls + 1; // +1 for average column
            if (show_appreciations) colspan++;
            
            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            worksheet.mergeCells(header_row_idx, col, header_row_idx, col + colspan - 1);

            // Row 2: Chapters
            let col2 = col;
            (subject_header.chapters_orders || []).forEach(chapter_id => {
              let chapter = subject_header.chapters[chapter_id];
              let controls_count = (chapter.controls_orders || []).length || 1;
              header_row2.getCell(col2).value = chapter.name;
              header_row2.getCell(col2).style = headerStyle;
              worksheet.mergeCells(header_row_idx + 1, col2, header_row_idx + 1, col2 + controls_count - 1);
              col2 += controls_count;
            });
            
            header_row2.getCell(col2).value = 'Moyenne';
            header_row2.getCell(col2).style = headerStyle;
            worksheet.mergeCells(header_row_idx + 1, col2, header_row_idx + 2, col2);
            col2++;

            if (show_appreciations) {
              header_row2.getCell(col2).value = 'Appréciation';
              header_row2.getCell(col2).style = headerStyle;
              worksheet.mergeCells(header_row_idx + 1, col2, header_row_idx + 2, col2);
              col2++;
            }

            // Row 3: Controls
            let col3 = col;
            (subject_header.chapters_orders || []).forEach(chapter_id => {
              let chapter = subject_header.chapters[chapter_id];
              (chapter.controls_orders || []).forEach(control_id => {
                let control = chapter.controls[control_id];
                header_row3.getCell(col3).value = control ? control.name : '';
                header_row3.getCell(col3).style = headerStyle;
                col3++;
              });
            });

            col = col2;
          } else if (details_by_chapters) {
            // Chapters only
            let chapters_count = (subject_header.chapters_orders || []).length;
            let colspan = chapters_count + 1; // +1 for average
            if (show_appreciations) colspan++;

            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            worksheet.mergeCells(header_row_idx, col, header_row_idx + 1, col + colspan - 1);

            let col3 = col;
            (subject_header.chapters_orders || []).forEach(chapter_id => {
              let chapter = subject_header.chapters[chapter_id];
              header_row3.getCell(col3).value = chapter.name;
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            });

            header_row3.getCell(col3).value = 'Moyenne';
            header_row3.getCell(col3).style = headerStyle;
            col3++;

            if (show_appreciations) {
              header_row3.getCell(col3).value = 'Appréciation';
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            }

            col = col3;
          } else if (details_by_controls) {
            // Controls only (no chapters)
            let controls_count = (subject_header.controls_orders || []).length;
            let colspan = controls_count + 1; // +1 for average
            if (show_appreciations) colspan++;

            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            worksheet.mergeCells(header_row_idx, col, header_row_idx + 1, col + colspan - 1);

            let col3 = col;
            (subject_header.controls_orders || []).forEach(control_id => {
              let control = subject_header.controls[control_id];
              header_row3.getCell(col3).value = control ? control.name : '';
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            });

            header_row3.getCell(col3).value = 'Moyenne';
            header_row3.getCell(col3).style = headerStyle;
            col3++;

            if (show_appreciations) {
              header_row3.getCell(col3).value = 'Appréciation';
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            }

            col = col3;
          } else {
            // Subject average only
            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            if (show_appreciations) {
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
              col++;
              header_row.getCell(col).value = 'Appréciation';
              header_row.getCell(col).style = headerStyle;
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
              col++;
            } else {
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
              col++;
            }
          }
        });
      }

      // Exam notes column
      if (show_exam_notes) {
        header_row.getCell(col).value = 'Moyenne examen normalisé';
        header_row.getCell(col).style = headerStyle;
        worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
        col++;
      }
    } else {
      // High school structure (hight_school === true) - controls only, no chapters
      
      // Average columns
      if (show_avg) {
        if (show_general_avg) {
          header_row.getCell(col).value = 'Moyenne S1';
          header_row.getCell(col).style = headerStyle;
          worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
          col++;
        }

        header_row.getCell(col).value = show_general_avg ? 'Moyenne S2' : 'Moyenne S1';
        header_row.getCell(col).style = headerStyle;
        worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
        col++;

        if (show_general_avg) {
          header_row.getCell(col).value = 'Moyenne générale';
          header_row.getCell(col).style = headerStyle;
          worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
          col++;
        }
      }

      // Subject headers with controls only (no chapters for high school)
      if (subjects_headers_orders && subjects_headers) {
        subjects_headers_orders.forEach(subject_id => {
          let subject_header = subjects_headers[subject_id];
          if (!subject_header) return;

          if (details_by_controls) {
            // Controls only structure for high school
            let controls_count = (subject_header.controls_orders || []).length;
            let colspan = controls_count + 1; // +1 for average
            if (show_appreciations) colspan++;

            // Row 1: Subject name
            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            worksheet.mergeCells(header_row_idx, col, header_row_idx + 1, col + colspan - 1);

            // Row 3: Controls
            let col3 = col;
            (subject_header.controls_orders || []).forEach(control_id => {
              let control = subject_header.controls[control_id];
              header_row3.getCell(col3).value = control ? control.name : '';
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            });

            // Average column
            header_row3.getCell(col3).value = 'Moyenne';
            header_row3.getCell(col3).style = headerStyle;
            col3++;

            if (show_appreciations) {
              header_row3.getCell(col3).value = 'Appréciation';
              header_row3.getCell(col3).style = headerStyle;
              col3++;
            }

            col = col3;
          } else {
            // Subject average only
            header_row.getCell(col).value = subject_header.name;
            header_row.getCell(col).style = headerStyle;
            if (show_appreciations) {
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 1, col);
              col++;
              header_row.getCell(col).value = 'Appréciation';
              header_row.getCell(col).style = headerStyle;
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 1, col);
              col++;
            } else {
              worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
              col++;
            }
          }
        });
      }

      // Exam notes column
      if (show_exam_notes) {
        header_row.getCell(col).value = 'Moyenne examen normalisé';
        header_row.getCell(col).style = headerStyle;
        worksheet.mergeCells(header_row_idx, col, header_row_idx + 2, col);
        col++;
      }
    }

    // Data rows
    let current_row = header_row_idx + 3;
    let student_count = 0;

    Object.keys(users_global_notes_by_classes).forEach((classe_id, idx_cl) => {
      let classe_data = users_global_notes_by_classes[classe_id];
      let students_order = classe_data['students_order'] || [];
      
      if (ordered_ids_students) {
        let others_students_ids = students_order.filter(std_id => ordered_ids_students.indexOf(std_id) === -1);
        if (order_sign > 0) {
          students_order = [...others_students_ids, ...ordered_ids_students];
        } else {
          students_order = [...ordered_ids_students, ...others_students_ids];
        }
      }

      students_order.forEach((student_id, idx_std) => {
        if (students_ids_to_hide.indexOf(student_id) !== -1) {
          return;
        }

        let student_data = classe_data['students'][student_id];
        if (!student_data) return;

        let student_cols_to_show = students_cols_to_show[student_id];
        if (!student_cols_to_show) return;

        student_count++;
        let data_row = worksheet.getRow(current_row);
        let data_col = 1;

        // N.O
        data_row.getCell(data_col).value = student_data.cne || '';
        data_row.getCell(data_col).style = contentStyle;
        data_col++;

        // Name
        data_row.getCell(data_col).value = (student_data.full_name || '') + (student_data.is_in_activity_classe ? ' *' : '');
        data_row.getCell(data_col).style = contentStyle;
        data_col++;

        // Birthday
        data_row.getCell(data_col).value = student_data.birthday ? moment(student_data.birthday).format('DD-MM-YYYY') : '';
        data_row.getCell(data_col).style = contentStyle;
        data_col++;

        // Class
        data_row.getCell(data_col).value = student_data.classe_name || '';
        data_row.getCell(data_col).style = contentStyle;
        data_col++;

        // Student data columns (notes, averages, etc.)
        student_cols_to_show.forEach((col_to_show, idx) => {
          console.log('current_row: ', current_row)
          console.log('data_col: ', data_col)
          console.log('value: ', col_to_show[2] || col_to_show[0])
          let cell = data_row.getCell(data_col);
          cell.value = col_to_show[2] || col_to_show[0];
          cell.style = Object.assign({}, contentStyle);
          
          if (col_to_show[1]) {
            cell.style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FF' + col_to_show[1].replace('#', '') }
            };
          }
          data_col++;
        });

        current_row++;
      });
    });

    // Statistics rows
    if (Object.keys(users_global_notes_by_classes).length > 0) {
      current_row++; // Empty row

      // Average row
      let avg_row = worksheet.getRow(current_row);
      avg_row.getCell(4).value = 'Moyenne';
      avg_row.getCell(4).style = contentStyle;
      
      let avg_col = start_data_col;
      (items_c_avg_list || []).forEach((il, idx) => {
        if (il === null) {
          avg_col++;
          return;
        }
        let avg_ = il.sum_notes === undefined ? '' : parseFloat(parseInt(Math.round(100 * parseFloat(il.sum_notes || 0) / (il.nbr_students_noted || 1))) / 100);
        avg_row.getCell(avg_col).value = avg_;
        let threshold_style = Object.assign({}, contentStyle);
        let color_ = get_grade_threshold_color(avg_, grade_thresholds);
        if (color_) {
          threshold_style.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF' + color_.replace('#', '') }
          };
        }
        avg_row.getCell(avg_col).style = threshold_style;
        avg_col++;
      });
      current_row++;

      current_row++; // Empty row

      // Grade thresholds rows
      (grade_thresholds || []).forEach((gt, idx_gt) => {
        let threshold_row = worksheet.getRow(current_row);
        threshold_row.getCell(4).value = gt.min_grade + ' - ' + gt.max_grade;
        let threshold_style = Object.assign({}, contentStyle);
        if (gt.color) {
          threshold_style.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF' + gt.color.replace('#', '') }
          };
        }
        threshold_row.getCell(4).style = threshold_style;

        let threshold_col = start_data_col;
        (items_list || []).forEach((il, idx) => {
          if (il === null) {
            threshold_col++;
            return;
          }
          let percent = parseFloat(parseInt(Math.round(10000 * parseFloat(il[gt.color] || 0) / (notes_percents_tresholds.total_students || 1))) / 100);
          let cell = threshold_row.getCell(threshold_col);
          cell.value = percent + '%';
          cell.style = threshold_style;
          threshold_col++;
        });
        current_row++;
      });

      // Other/Not noted row
      if (not_noted_items) {
        let other_row = worksheet.getRow(current_row);
        other_row.getCell(4).value = 'Autre';
        other_row.getCell(4).style = contentStyle;

        let other_col = start_data_col;
        (items_list || []).forEach((il, idx) => {
          if (il === null) {
            other_col++;
            return;
          }
          let percent = parseFloat(parseInt(Math.round(10000 * parseFloat((il['#ffffff'] || 0) + (il['#808080'] || 0)) / (notes_percents_tresholds.total_students || 1))) / 100);
          other_row.getCell(other_col).value = percent + '%';
          other_row.getCell(other_col).style = contentStyle;
          other_col++;
        });
        current_row++;
      }

      // Total row
      let total_row = worksheet.getRow(current_row);
      total_row.getCell(4).value = 'Total';
      total_row.getCell(4).style = headerStyle;

      let total_col = start_data_col;
      (items_list || []).forEach((il, idx) => {
        if (il === null) {
          total_col++;
          return;
        }
        total_row.getCell(total_col).value = Math.round(totals_stats[idx] || 0) + '%';
        total_row.getCell(total_col).style = headerStyle;
        total_col++;
      });
    }

    worksheet.properties.defaultColWidth = 15;
    
    return tablea_recap_des_notes;
  } catch (error) {
    console.error('Error in handleExportTRN:', error);
    return null;
  }
}

export const sortByCategorySection = (arr) => {
  return arr.sort((a, b) => {
    let va = a.section.name;
    let vb = b.section.name;

      if(va == "reporting_inscriptions"){
        va = "1_" + va;
      }
      else if(va == "reporting_students"){
        va = "2_" + va;
      }
      else if(va == "reporting_professors"){
        va = "3_" + va;
      }
      else if(va == "reporting_evaluations"){
        va = "4_" + va;
      }
      else if(va == "reporting_payments"){
        va = "5_" + va;
      }

      if(vb == "reporting_inscriptions"){
        vb = "1_" + vb;
      }
      else if(vb == "reporting_students"){
        vb = "2_" + vb;
      }
      else if(vb == "reporting_professors"){
        vb = "3_" + vb;
      }
      else if(vb == "reporting_evaluations"){
        vb = "4_" + vb;
      }
      else if(vb == "reporting_payments"){
        vb = "5_" + vb;
      }

    const aEmpty = va === undefined || va === null || va === "";
    const bEmpty = vb === undefined || vb === null || vb === "";

    // both empty → equal
    if (aEmpty && bEmpty) return 0;

    // only a empty → a goes last
    if (aEmpty) return 1;

    // only b empty → b goes last
    if (bEmpty) return -1;

    // normal comparison
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  });
}

export const get_scholar_years_ids_from_periods = (scholar_years, date_start, date_end) => {
  return scholar_years.filter(sy => {
    let start_sy = new Date(sy.start_year, 8, 1);
    let end_sy = new Date(sy.start_year + 1, 7, 31);
    window.moment = moment;
    let res = moment(start_sy).isBetween(moment(date_start), moment(date_end), null, '[]') || moment(end_sy).isBetween(moment(date_start), moment(date_end), null, '[]');
    return res;
  }).map(sy => sy.id);
};
export const get_min_scholar_year_date = (scholar_year, as_moment_object) => {
  scholar_year = scholar_year || get("current_year");
  var res = (scholar_year || null) && new Date(scholar_year.start_year, 6, 1);
  return as_moment_object ? res && moment(res) : res;
};
export const get_max_scholar_year_date = (scholar_year, as_moment_object) => {
  scholar_year = scholar_year || get("current_year");
  var res = (scholar_year || null) && new Date(scholar_year.start_year + 1, 5, 30);
  return as_moment_object ? res && moment(res) : res;
};
export const format_str_number = (val, nbr_chars, is_number, add_dot) => {
  var str = String(val);
  if(is_number){
    if(add_dot){
      str = String(val.toFixed(2))
    }
  }
  if(str.length > nbr_chars){
    str = str.substring(str.length - nbr_chars, str.length);
  }
  else if(str.length < nbr_chars){
    if(is_number){
      while(str.length < nbr_chars){
        str = "0" + str
      }
    }
    else{
      while(str.length < nbr_chars){
        str = str + " "
      }
    }
  }
  return str;
}

const levels_appreciations_limitations_massar = {
  "cp-8a7d26c0cc1c47ad81f3032e82b90a8e": 41, 
  "ce1-8b6c3f5c48534156bcd420e71b1bd035": 41, 
  "ce2-8d3d0240a5db45ec9b573861e5f7f6c3": 41, 
  "cm1-94c01e5dfe134e0aa754fb7bc000e626": 41, 
  "cm2-fb49ea6b9cf543968b73d83406d934ae": 41, 
  "6eme-757dc9be360b48a39fa4b8a41edc7084": 16, 
}

export const get_levels_appreciations_limitations_massar = level_id => {
  if(level_id){
    return levels_appreciations_limitations_massar[level_id] || -1;
  }
  return levels_appreciations_limitations_massar;
}

export const serverResponse = (message, handleCloe) => {
  return <div className="server_message" style={{
    position: "fixed",
    width: "100%",
    zIndex: "2200000000",
    top: "0",
    padding: "15px",
    textalign: "center",
    background: "#808080",
    color: "white",
    fontSize: "20px",
  }}>
    <div style={{display: "relative"}}>
      <div className="message" style={{textAlign: "center"}}>
        {message}
      </div>
      <div className="close" onClick={handleCloe} style={{
        position: "absolute",
        top: "50%",
        right: "17px",
        border: "5px solid #fff",
        width: "40px",
        height: "40px",
        textAlign: "center",
        color: "#fff",
        borderRadius: "50%",
        fontSize: "17px",
        lineHeight: "28px",
        background: "#00b3a9",
        boxShadow: "0 0 5px -1px rgba(0, 0, 0, 0.3)",
        transform: "translateY(-50%)",
        cursor: "pointer",
      }}>
        &times;
      </div>
    </div>
  </div>
}

export const format_s3_file_name = (file_name, split_by_dash, split_by) => {
  file_name = decodeURI(file_name);
  if(split_by){
    var name = file_name.split(split_by)[1];
    if(name){
      return name;
    }
  }
  if(file_name && split_by_dash){
    file_name = file_name.split(' - ')[1] || file_name.split(' - ')[0] || " "
  }
  else if(!file_name || file_name.indexOf('_audio_') != -1){
    return file_name;
  }
  var filename_tab = file_name.split('_');
  if(filename_tab.length > 2){
    filename_tab.shift();
    filename_tab.shift();
  }
  return filename_tab.join('_');
}

export const add_one_to_time_str = (time_str) => {
  let time_plited = time_str.split(":");
  let new_hour = parseInt(time_plited[0]) + 1;
  time_str = (new_hour < 10 ? "0" : "") + new_hour + ":" + time_plited[1];
  return time_str;
}
export const fix_absences_hours = (absences) => {
  return (absences || []).map(absence => {
    let seance_date = absence.seance_date;
    if(!seance_date.seance_id){
      return absence;
    }
    let date_to_compare_str = seance_date.day;
    seance_date.correct_start = seance_date.correct_start || seance_date.start;
    seance_date.correct_end = seance_date.correct_end || seance_date.end;
    if (START_RAMADA_STR <= date_to_compare_str /*&& END_RAMADA_STR >= date_to_compare_str*/){
      if(moment(seance_date.correct_start).utc().format("HH:mm") == moment(seance_date.correct_start).format("HH:mm")){
          var new_start = moment(seance_date.correct_start).add(1, "hour");
          var new_end = moment(seance_date.correct_end).add(1, "hour");
          seance_date.start = new_start.toDate();
          seance_date.end = new_end.toDate();
          seance_date.start_time = add_one_to_time_str(seance_date.start_time);
          absence.seance_date = seance_date;
          let seance = absence.seance;
          if(seance){
            seance.start = seance_date.start;
            seance.end = seance_date.end;
          }
          absence.seance = seance;
        }
    }
    else if(moment(seance_date.correct_start).utc().format("HH:mm") == moment(seance_date.correct_start).format("HH:mm")){
      var new_start = moment(seance_date.correct_start).add(1, "hour");
      var new_end = moment(seance_date.correct_end).add(1, "hour");
      seance_date.start = new_start.toDate();
      seance_date.end = new_end.toDate();
      seance_date.start_time = add_one_to_time_str(seance_date.start_time);
      absence.seance_date = seance_date;
      let seance = absence.seance;
      if(seance){
        seance.start = seance_date.start;
        seance.end = seance_date.end;
      }
      absence.seance = seance;
    }
    return absence;
  })
}

export const fix_seances_hours = (seances, selected_date) => {
  var week_start = selected_date && moment(selected_date).startOf("week");
  return (seances || []).map(seance => {
    seance.correct_start = seance.correct_start || seance.start;
    seance.correct_end = seance.correct_end || seance.end;
    if(!week_start){
      week_start = moment(seance.seance_day, "YYYY-MM-DD").startOf("week");
    }
    var date_to_compare = week_start.add(moment(seance.correct_start).day() - week_start.day(), "days");
    var date_to_compare_str = moment(date_to_compare).format("YYYY-MM-DD");
    if ((!seance.seance_from || moment(seance.seance_from).format("YYYY-MM-DD") <= date_to_compare_str) && (!seance.seance_to || moment(seance.seance_to).format("YYYY-MM-DD") >= date_to_compare_str)){
      if (START_RAMADA_STR <= date_to_compare_str /*&& END_RAMADA_STR >= date_to_compare_str*/){
        if(moment(seance.correct_start).utc().format("HH:mm") == moment(seance.correct_start).format("HH:mm")){
            var new_start = moment(seance.correct_start).add(1, "hour");
            var new_end = moment(seance.correct_end).add(1, "hour");
            seance.start = new_start.toDate();
            seance.end = new_end.toDate();
        }
      }
      else if(moment(seance.correct_start).utc().format("HH:mm") == moment(seance.correct_start).format("HH:mm")){
        var new_start = moment(seance.correct_start).add(1, "hour");
        var new_end = moment(seance.correct_end).add(1, "hour");
        seance.start = new_start.toDate();
        seance.end = new_end.toDate();
      }
    }
    else if(moment(seance.correct_start).utc().format("HH:mm") == moment(seance.correct_start).format("HH:mm")){
      var new_start = moment(seance.correct_start).add(1, "hour");
      var new_end = moment(seance.correct_end).add(1, "hour");
      seance.start = new_start.toDate();
      seance.end = new_end.toDate();
    }
    if(seance.journals){
      seance.journals = fix_journals_hours(seance.journals, selected_date);
    }
    return seance;
  })
}
export const fix_hour = (time, selected_date) => {
  var selected_date_str = moment(selected_date).format("YYYY-MM-DD");
  if (selected_date_str){
    if (START_RAMADA_STR <= selected_date_str /*&& END_RAMADA_STR >= selected_date_str*/){
      if(moment(time).utc().format("HH:mm") == moment(time).format("HH:mm")){
        time = moment(time).add(1, "hour");
      }
    }
    else if(moment(time).utc().format("HH:mm") == moment(time).format("HH:mm")){
      time = moment(time).add(1, "hour");
    }
  }
  return time;
}
export const calc_minutes = (start, end) => {
  let diff_minutes = moment(end).diff(moment(start), "minutes");
  return diff_minutes > 0 ? diff_minutes : 0;
}
export const add_subject_to_list = (list_subject, subject) => {
  if(subject && list_subject.indexOf(subject.name) === -1){
    list_subject.push(subject.name)
  }
  return list_subject;
}
export const convert_minutes_to_hours = (minutes, as_str) => {
  let nbr_hours = parseInt(minutes / 60);
  let rest_minutes = minutes % 60;
  if(nbr_hours && rest_minutes){
    return nbr_hours + "H" + rest_minutes;
  }
  else if(nbr_hours){
    return nbr_hours + "H";
  }
  else if(rest_minutes){
    return rest_minutes + "m";
  }
  return "";
}
export const fix_date = (date, selected_date, add) => {
  var date_to_compare_str = moment(selected_date).format("YYYY-MM-DD");
  var date_to_compare2_str = moment().format("YYYY-MM-DD");
  if ((START_RAMADA_STR <= date_to_compare_str /*&& END_RAMADA_STR >= date_to_compare_str*/)){
    if(moment(date).utc().format("HH:mm") != moment(date).format("HH:mm")){
        var new_start = moment(date).add(add ? 1 : -1, "hour");
        date = new_start.toDate();
    }
    else if((START_RAMADA_STR <= date_to_compare2_str /*&& END_RAMADA_STR >= date_to_compare2_str*/)){
      if(moment(date).utc().format("HH:mm") == moment(date).format("HH:mm")){
        var new_start = moment(date).add(add ? 1 : -1, "hour");
        date = new_start.toDate();
      }
    }
  }
  return date;
}
export const is_ramadan = (selected_date, se) => {
  var date_to_compare_str = moment(selected_date).format("YYYY-MM-DD");
  let cond = true;
  if(false && se && se.created_at){
    var created_at_str = moment(se.created_at).format("YYYY-MM-DD");
    cond = (START_RAMADA_STR <= created_at_str /*&& END_RAMADA_STR >= created_at_str*/);

  }
  return cond && (START_RAMADA_STR <= date_to_compare_str /*&& END_RAMADA_STR >= date_to_compare_str*/);
}
export const fix_journals_hours = (journals, selected_date) => {
  var week_start = selected_date && moment(selected_date).startOf("week");
  return (journals || []).map(journal => {
    journal.correct_start = journal.correct_start || journal.journal_start;
    journal.correct_end = journal.correct_end || journal.journal_end;
    if(!week_start){
      week_start = moment().startOf("week");
    }
    var date_to_compare = week_start.add(moment(journal.correct_start).day() - week_start.day(), "days");
    var date_to_compare_str = moment(date_to_compare).format("YYYY-MM-DD");
    if (START_RAMADA_STR <= date_to_compare_str /*&& END_RAMADA_STR >= date_to_compare_str*/){
      if(moment(journal.correct_start).utc().format("HH:mm") == moment(journal.correct_start).format("HH:mm")){
          var new_start = moment(journal.correct_start).add(1, "hour");
          var new_end = moment(journal.correct_end).add(1, "hour");
          journal.journal_start = new_start.toDate();
          journal.journal_end = new_end.toDate();
        }
    }
    else if(moment(journal.correct_start).utc().format("HH:mm") == moment(journal.correct_start).format("HH:mm")){
      var new_start = moment(journal.correct_start).add(1, "hour");
      var new_end = moment(journal.correct_end).add(1, "hour");
      journal.journal_start = new_start.toDate();
      journal.journal_end = new_end.toDate();
    }
    return journal;
  })
}
export const fix_seance_hours = (time_moment, selected_date, add_hour) => {
  var selected_date_str = moment(selected_date).format("YYYY-MM-DD");
  if(selected_date_str >= START_RAMADA_STR /*&& selected_date_str <= END_RAMADA_STR*/){
    if(moment(time_moment).utc().format("HH:mm") == moment(time_moment).format("HH:mm")){
      return moment(time_moment).add(add_hour ? 1 : -1, "hour");
    }
  }
  else{
    var h_ = (moment(time_moment).toDate().getTimezoneOffset() / 60) + 1;
    return moment(time_moment).add(-h_, "hour");
  }
  return moment(time_moment);
}

export const return_stats_color = (value, type, ranges) => {
    value = value || undefined;
    var res = "#FF0000FF";
    if(type == "date"){
      if(!value){
        var range = ranges[ranges.length - 1];
        res = range.color;
      }
      else{
        var diff_days = moment().diff(moment(value), "days");
        if(diff_days <= 0){
          var range = ranges[0];
          res = range.color;
        }
        else{
          ranges.map(range => {
            if(range.start <= diff_days && range.end >= diff_days){
              res = range.color;
            }
          })
        }
      }
    }
    if(type == "percent"){
      if(!value){
        var range = ranges[ranges.length - 1];
        res = range.color;
      }
      else{
        ranges.map(range => {
          if(range.start < value && range.end >= value){
            res = range.color;
          }
        })
      }
    }
    return res;
}


export const soapFunction = () => {

  var url = 'https://api.brightsignnetwork.com/2014/12/SOAP/WSDL/';
  var soapMessage = '<?xml version="1.0" encoding="utf-8"?>\
    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://www.w3.org/2003/05/soap-envelope">\
      <soap:Header/>\
      <soap:Body>\
      </soap:Body>\
    </soap:Envelope>';
  var objXMLHttpRequest = new XMLHttpRequest();
        objXMLHttpRequest.open("GET", url, true);
        objXMLHttpRequest.onreadystatechange = function () {
          if (objXMLHttpRequest.readyState == 4 && objXMLHttpRequest.status == 200) {
            var result = objXMLHttpRequest.responseXML;
            alert(objXMLHttpRequest.responseText);
            alert(objXMLHttpRequest.responseXML);
          }
        }
        objXMLHttpRequest.setRequestHeader("Content-Type", "text/xml; charset=utf-8");


        objXMLHttpRequest.send(soapMessage);
        var response = objXMLHttpRequest.responseXML;
        alert(objXMLHttpRequest.responseText+ "  "+ response);
}

const getElementsFromXML = (elementsXml) => {
  var result_list = [];
  for (var i=0; i < elementsXml.length; i++){
    result_list.push(elementsXml[i].attributes[0].value);
  }
  return result_list;
}

export const getRessourcesFromXML = (ressourcesXml) => {
  var ressources = [];
  var ressources_items = ressourcesXml.getElementsByTagName('ns1:Ressource');
  for (var i=0; i < ressources_items.length; i++){
    var ressource_item = ressources_items[i];
    ressources.push({
      editor_name: (ressource_item.getElementsByTagName("EditeurRessource")[0] || {}).innerHTML || "",
      image_url: (ressource_item.getElementsByTagName("UrlVisuelRessource")[0] || {}).innerHTML || "",
      title: (ressource_item.getElementsByTagName("TitreRessource")[0] || {}).innerHTML || "",
      access_url: (ressource_item.getElementsByTagName("UrlAccesressource")[0] || {}).innerHTML || "",
      description: (ressource_item.getElementsByTagName("Description")[0] || {}).innerHTML || "",
      is_kne: true,
    });
  }
  return ressources;
}

export const KNEChild = () => {
  var cle = create_kne_key();
  var uai = "Educad20";
  var soap_request = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="https://www.kiosque-edu.com/webservices">
      <soapenv:Header/>
      <soapenv:Body>
        <web:UserRessourcesCatalog>
            <input>
              <!--You may enter the following 15 items in any order-->
              <Cle>${cle}</Cle>
              <Pf>Koolskools</Pf>
              <ENTPersonStructRattachUAI>${uai}</ENTPersonStructRattachUAI>
              <ENTPersonProfils>National_ELV</ENTPersonProfils>
              <EnfantId></EnfantId>
              <ENTEleveMEF></ENTEleveMEF>
              <ENTEleveCodeEnseignements></ENTEleveCodeEnseignements>
              <ENTEleveClasses></ENTEleveClasses>
              <ENTAuxEnsClassesMatieres></ENTAuxEnsClassesMatieres>
              <user>recette2021</user>
              <ENTAuxEnsGroupes></ENTAuxEnsGroupes>
              <ENTAuxEnsClasses>Classe C|Classe D</ENTAuxEnsClasses>
              <ENTAuxEnsMEF></ENTAuxEnsMEF>
              <ENTStructureTypeStruct></ENTStructureTypeStruct>
            </input>
        </web:UserRessourcesCatalog>
      </soapenv:Body>
    </soapenv:Envelope>`;
              //<ENTEleveMEF>211100</ENTEleveMEF>
  var url = "https://www.kiosque-edu.com/webservices";
    
  // var objXMLHttpRequest = new XMLHttpRequest();
  // objXMLHttpRequest.open("POST", url, true);
  // debugger
  // objXMLHttpRequest.onreadystatechange = function () {
  //   debugger
  //   if (objXMLHttpRequest.readyState == 4 && objXMLHttpRequest.status == 200) {
  //     var resultXml = objXMLHttpRequest.responseXML.documentElement;
  //     var ressources_xml = resultXml.getElementsByTagName("ressources")[0];
  //     var ressources = getRessourcesFromXML(ressources_xml);
  //     console.log(ressources)
  //   }
  // }
  // // objXMLHttpRequest.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
  // // objXMLHttpRequest.setRequestHeader("Accept", "*/*");
  // objXMLHttpRequest.send(soap_request);

  init_user_ressource().then(objXMLHttpRequest => {
    if (objXMLHttpRequest.readyState == 4 && objXMLHttpRequest.status == 200) {
      var resultXml = objXMLHttpRequest.responseXML.documentElement;
      var ressources_xml = resultXml.getElementsByTagName("ressources")[0];
    }
  });
  return axios.post(url, soap_request).then(res=>{
      return res.request;
    }).catch(err=>{console.log(err)});
}

export const init_user_ressource = () => {
  var cle = create_kne_key();
  var uai = "Educad20";
  var soap_request = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="https://www.kiosque-edu.com/webservices">
      <soapenv:Header/>
      <soapenv:Body>
        <web:InitUserRessourcesCatalog>
            <input>
              <!--You may enter the following 15 items in any order-->
              <Cle>${cle}</Cle>
              <Pf>Koolskools</Pf>
              <ENTPersonStructRattachUAI>${uai}</ENTPersonStructRattachUAI>
            </input>
        </web:InitUserRessourcesCatalog>
      </soapenv:Body>
    </soapenv:Envelope>`;
  var url = "https://www.kiosque-edu.com/webservices";
  return axios.post(url, soap_request).then(res=>{
      return res.request;
    }).catch(err=>{console.log(err)});
}

export const KNEProfessor = () => {
  var cle = create_kne_key();
    var soap_request = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="https://www.kiosque-edu.com/webservices">
      <soapenv:Header/>
      <soapenv:Body>
        <web:UserRessourcesCatalog>
            <input>
              <!--You may enter the following 15 items in any order-->
              <Cle>${cle}</Cle>
              <Pf>Koolskools</Pf>
              <ENTPersonStructRattachUAI>ecprodV9</ENTPersonStructRattachUAI>
              <ENTPersonProfils>National_ENS</ENTPersonProfils>
              <EnfantId></EnfantId>
              <ENTEleveMEF></ENTEleveMEF>
              <ENTEleveCodeEnseignements></ENTEleveCodeEnseignements>
              <ENTEleveClasses></ENTEleveClasses>
              <ENTAuxEnsClassesMatieres></ENTAuxEnsClassesMatieres>
              <user>recette2021</user>
              <ENTAuxEnsGroupes></ENTAuxEnsGroupes>
              <ENTAuxEnsClasses>Classe C|Classe D</ENTAuxEnsClasses>
              <ENTAuxEnsMEF></ENTAuxEnsMEF>
              <ENTStructureTypeStruct></ENTStructureTypeStruct>
            </input>
        </web:UserRessourcesCatalog>
      </soapenv:Body>
    </soapenv:Envelope>`;
  var url = "https://www.kiosque-edu.com/webservices";
    
  return axios.post(url, soap_request).then(res=>{
    return res.request;
  }).catch(err=>{console.log(err)});
}
export const EdulibCatalogue = () => {
  return getEdulibCatalogFromKoolskools();
  // var edulib_data = get("edulib_data");
  // if(edulib_data && edulib_data.access_token){
  //   var api_time_tecs = moment().diff(moment(edulib_data.api_time), "seconds");
  //   if( api_time_tecs >= (edulib_data.expires_in || 0)){
  //     return getEdulibToken(edulib_data);
  //   }
  //   else{
  //     return getEdulibCatalog(edulib_data);
  //   }
  // }
  // else{
  //   return getEdulibToken();
  // }
}

// export const getEdulibToken = (edulib_data) => {
//   var data = {
//     client_id: "0f738379d8d107e3067bbe17f710d588ef5e5bfc3a2fe69f854f6293c8648845",
//     client_secret: "6ac7a1a2f46841ba9dc3dfc231a657efb2ee1eff08f0e57e5ef814b30b29d90a",
//   }
//   if(edulib_data){
//     data.refresh_token = edulib_data.refresh_token;
//     data.grant_type = "refresh_token";
//   }
//   else{
//     data.username = "nouredineamrani@yahoo.fr";
//     data.password = "Edulib@21!";
//     data.grant_type = "password";
//   }
//   return axios.post("https://staging.edulib.fr/oauth/token", data).then(res=>{
//     if(edulib_data){
//       edulib_data.access_token = res.data.access_token;
//       edulib_data.refresh_token = res.data.refresh_token;
//       edulib_data.expires_in = res.data.expires_in;
//     }
//     else{
//       edulib_data = {
//         access_token: res.data.access_token,
//         refresh_token: res.data.refresh_token,
//         expires_in: res.data.expires_in,
//         token_type: res.data.token_type,
//         scope: res.data.scope,
//         created_at: res.data.created_at,
//       }
//     }
//     edulib_data.api_time = moment().toDate();
//     set("edulib_data", edulib_data);
//     return getEdulibCatalog(edulib_data);
//   }).catch(err=>{console.log(err)});
// }
export const getEdulibCatalog = (edulib_data) => {
  var establishment_account_id = "1000001H";
  var establishment_account_id = "1000368G";
  return get_edulib_catalog(edulib_data.access_token, establishment_account_id).then(res=>{
    var ressources = [];
    res.map(resource => {
      ressources.push(resource);
    })
    return ressources;
  }).catch(err=>{console.log(err)});
}
export const getEdulibCatalogFromKoolskools = () => {
  return get_catalog_from_koolskools("edulib").then(res=>{
    var ressources = [];
    res.catalog.map(resource => {
      ressources.push(resource);
    })
    return ressources;
  }).catch(err=>{console.log(err)});
}

export const soapTest2 = () => {
    var soap_request = '\
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="https://www.kiosque-edu.com/webservices">\
      <soapenv:Header/>\
      <soapenv:Body>\
        <web:UserRessourcesCatalog>\
            <input>\
              <!--You may enter the following 15 items in any order-->\
              <Cle>04b70c9e04d423caa1489ec1c7469ef0</Cle>\
              <Pf>Koolskools</Pf>\
              <ENTPersonStructRattachUAI>ecprodV9</ENTPersonStructRattachUAI>\
              <ENTPersonProfils>National_ENS</ENTPersonProfils>\
              <EnfantId></EnfantId>\
              <ENTEleveMEF></ENTEleveMEF>\
              <ENTEleveCodeEnseignements></ENTEleveCodeEnseignements>\
              <ENTEleveClasses></ENTEleveClasses>\
              <ENTAuxEnsClassesMatieres></ENTAuxEnsClassesMatieres>\
              <user>recette2021</user>\
              <ENTAuxEnsGroupes></ENTAuxEnsGroupes>\
              <ENTAuxEnsClasses>Classe C|Classe D</ENTAuxEnsClasses>\
              <ENTAuxEnsMEF></ENTAuxEnsMEF>\
              <ENTStructureTypeStruct></ENTStructureTypeStruct>\
            </input>\
        </web:UserRessourcesCatalog>\
      </soapenv:Body>\
    </soapenv:Envelope>';
  var url = "https://www.kiosque-edu.com/webservices";
  axios.post(url,
    soap_request,
    {headers:
      {'Content-Type': 'application/xml'}
    }).then(res=>{
      console.log(res);
    }).catch(err=>{console.log(err)});
}

export const banks_list = [
  {value:0, label:'Attijariwafa bank'},
  {value:1, label:'Banque Populaire'},
  {value:2, label:'Bank of Africa(BMCE)'},
  {value:3, label:'Saham Bank (Ex: Société Générale)'},
  {value:4, label:'Crédit du Maroc'},
  {value:5, label:'BMCI'},
  {value:6, label:'Bank Al Yousr'},
  {value:7, label:'Bank Assafa'},
  {value:8, label:'CFG Bank'},
  {value:9, label:'CDG'},
  {value:10, label:'CIH'},
  {value:11, label:'Crédit Agricole'},
  {value:12, label:'Citibank'},
  {value:13, label:'Arab Bank'},
  {value:14, label:'Bank Al Akhdar'},
  {value:15, label:'Al Barid Bank'},
  {value:16, label:'Umnia Bank'},
  {value:17, label:'Trésorerie Générale'},
  {value:18, label:'Dar Al Amane'},
  {value:19, label:'Bti Bank'},
  {value:20, label:'Bank Al Maghrib'},
  {value:21, label:'Banques internationales'},
  {value:22, label:'Bank AL KARAM'},
  {value:23, label:'Arreda'},
  {value:24, label:'Wafa banque'}
]

export const units = [
  {value:0, label:'Unité 1'},
  {value:1, label:'Unité 2'},
  {value:2, label:'Unité 3'},
  {value:3, label:'Unité 4'},
  {value:4, label:'Unité 5'},
  {value:5, label:'Unité 6'},
  {value:6, label:'Unité 7'},
  {value:7, label:'Unité 8'},
  {value:8, label:'Autre'}
]
export const publication_filter_options = [
  {value:"yes", label:'Yes', label2:'Yes'},
  {value:"no", label:'No', label2:'No'},
]

export const get_stats_inscriptions = () => {
  return [
    {id:0, label: "In progress", className: 'bg-default', color: "#ccc"},
    {id:1, label: "Not accepted", className: 'bg-danger', color: "#dc3545"},
    {id:2, label: "Redo test", className:'bg-warning', color: "#ffc107"},
    {id:4, label: "On hold", className:'bg-info', color: "#17a2b8"},
    {id:6, label: "Inscrits au test et absentés", className: 'bg-success', color: "#28a745"},
    {id:5, label: "Admitted/Commitment", className: 'bg-success', color: "#28a745"},
    {id:3, label: "Admitted", className: 'bg-success', color: "#28a745"},
  ];
}
export const koolskools_tasks_priorities = [
  {value:3, label:'Very important', label2:'Very important'},
  {value:2, label:'Important', label2:'Important'},
  {value:1, label:'Not very important', label2:'Not very important'},
]

export const get_preinscription_step_1_options = (t) => {
  let res = [
    {id: "wrong_number", label: "Wrong number", label2: "Wrong number", className: 'bg-danger0 btn-bg-danger', color: "#dc3545"},
    {id: "not_answering", label: "Not answering", label2: "Not answering", className: 'bg-danger0 btn-bg-danger', color: "#dc3545"},
    {id: "voicemail", label: "Voicemail", label2: "Voicemail", className: 'bg-warning0 btn-bg-warning', color: "#ffc107"},
    {id: "ok", label: "Ok", label2: "Ok", className:'bg-success0 btn-bg-success', color: "#28a745"},
  ];
  if(t){
    return res.map(op => {
      op.label = t(op.label2);
      return op;
    });
  }
  return res;
}

export const get_document_request_property = (item, property, is_assistant) => {
  if(is_assistant && ["is_done", "is_picked_up"].indexOf(property) != -1){
    if("is_done" == property){
      return item["is_assistant_done"];
    }
    else if("is_picked_up" == property){
      return item["is_assistant_picked_up"];
    }
  }
  return item[property];
}
export const get_preinscription_step_2_options = (t) => {
  let res = [
    {id: "not_qualified", label: "Not Qualified", label2: "Not Qualified", className: 'bg-danger0 btn-bg-danger', color: "#dc3545"},
    {id: "to_be_contacted_again", label: "To be Contacted Again", label2: "To be Contacted Again", className: 'bg-warning0 btn-bg-warning', color: "#ffc107"},
    {id: "qualified", label: "Qualified", label2: "Qualified", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "interested_in_activities", label: "Interested in Activities", label2: "Interested in Activities", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "waiting_list", label: "Waiting list", label2: "Waiting list", className:'bg-warning0 btn-bg-success', color: "#ffc107"},
  ];
  if(t){
    return res.map(op => {
      op.label = t(op.label2);
      return op;
    });
  }
  return res;
}
export const get_preinscription_step_3_options = (t, is_interested_in_activities) => {
  let res = [
    {id: "scheduled_visit", label: "Scheduled Visit", label2: "Scheduled Visit", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "scheduled_test", label: "Scheduled Test", label2: "Scheduled Test", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "visit_and_test_scheduled", label: "Visit and test scheduled", label2: "Visit and test scheduled", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "visit_completed", label: "Visit completed", label2: "Visit completed", className:'bg-success0 btn-bg-success', color: "#28a745"},
    {id: "absent_at_the_visit", label: "Absent at the visit", label2: "Absent at the visit", className:'bg-warning0 btn-bg-success', color: "#ffc107"},
    {id: "absent_at_the_test", label: "Absent at test", label2: "Absent at test", className:'bg-warning0 btn-bg-success', color: "#ffc107"},
  ];
  if(is_interested_in_activities){
    res = [
      {id: "registered", label: "Registered", label2: "Registered", className:'bg-success0 btn-bg-success', color: "#28a745"},
      {id: "deleted", label: "Deleted", label2: "Deleted", className:'bg-success0 btn-bg-danger', color: "#dc3545"},
    ];
  }
  if(t){
    return res.map(op => {
      op.label = t(op.label2);
      return op;
    });
  }
  return res;
}

export const leftPad = (number, targetLength) => {
  var output = number + '';
  while (output.length < targetLength) {
      output = '0' + output;
  }
  return output;
}
export const get_bulletin_british_avg_items = () => {
  return [
    {id:"test", label: "Test", value: 34},
    {id:"effort", label: "Effort", value: 33},
    {id:"quality_of_work", label: "Quality of Work", value: 33},
  ];
}

export const cloneWithoutReference = (source, deep, semester_controls_orders, orders_new_semester_controls) => {
  deep = deep || 1;
  if(!source){
    return source;
  }
  if (Object.prototype.toString.call(source) === '[object Array]') {
    var clone = [];
    for (var i=0; i<source.length; i++) {
      clone[i] = cloneWithoutReference(source[i]);
    }
    return clone;
  } else if (typeof(source)=="object" && !(source instanceof Date)) {
    deep++;
    var clone = {};
    for(var prop in source) {
      if(source.hasOwnProperty(prop)) {
        if(semester_controls_orders && orders_new_semester_controls && deep == 4 && prop != "start_line" && prop != "appreciations" && typeof(source[prop]) != "object" && Object.prototype.toString.call(source[prop]) !== "[object Array]"){
          if(orders_new_semester_controls[semester_controls_orders[prop]]){
            clone[orders_new_semester_controls[semester_controls_orders[prop]]] = cloneWithoutReference(source[prop], deep, semester_controls_orders, orders_new_semester_controls);
          }
        }
        else{
          clone[prop] = cloneWithoutReference(source[prop], deep, semester_controls_orders, orders_new_semester_controls);
        }
      }
    }
    return clone;
  } else {
    return source;
  }
}

export const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex,
      temporaryArray = array.slice(0);


  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = temporaryArray[currentIndex];
      temporaryArray[currentIndex] = temporaryArray[randomIndex];
      temporaryArray[randomIndex] = temporaryValue;
  }

  return temporaryArray;
}

export function separate_milles_in_integer(integer) {
  if(integer < 1000){
    return integer;
  }
  var integer_str = integer + "";
  let added_str = integer_str.split(".")[1];
  integer_str = integer_str.split(".")[0];
  var list_strs = [];
  for(var i=integer_str.length; i>0;i-=3 ){
    if(i-3 < 0){
      list_strs.unshift(integer_str.substring(0, i));
    }
    else{
      list_strs.unshift(integer_str.substring(i-3, i));
    }
  }
  return list_strs.join(' ') + (added_str ? "." + added_str : "");
}

export const nbr_sms_by_content = (content) => {
  var nbr_chars_by_sms = 160;
  var str_length = content.length;
  var i = 0;
  var chars_type_1 = "@$_!\"#%&x'()*+,-./0123456789:;<=> ?|^{}[~]\\\nABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var chars_type_2 = "éèàüñöäùìòÇØøÅåÆæßÉ¤¡ÄÖÑÜ§¿£¥y";
  var chars_double = "€|^{}[~]\\\n";
  var nbr_double_char = 0;
  while(i<str_length){
      var char = content[i];
      if(chars_double.indexOf(char) > -1){
          nbr_double_char++;
      }
      if(chars_type_2.indexOf(char) > -1){
          if(nbr_chars_by_sms == 160){
              nbr_chars_by_sms = 140; 
          }
      }
      else if(chars_type_1.indexOf(char) > -1){
      }
      else{
          nbr_chars_by_sms = 70;
      }
      i++;
  }
  var nbr_chars = str_length + nbr_double_char;
  var added_chars_for_sequence = 0;
  if(nbr_chars_by_sms == 160 && nbr_chars > 160){
      added_chars_for_sequence += parseInt(nbr_chars / 160) * 3 + (nbr_chars % 160 > 157 ? 3 : 0);
  }
  else if(nbr_chars_by_sms == 140 && nbr_chars > 140){
      added_chars_for_sequence += parseInt(nbr_chars / 140) * 4 + (nbr_chars % 140 > 136 ? 4 : 0);
  }
  else if(nbr_chars_by_sms == 70 && nbr_chars > 70){
      added_chars_for_sequence += parseInt(nbr_chars / 70) * 3 + (nbr_chars % 70 > 67 ? 3 : 0);
  }
  nbr_chars += added_chars_for_sequence;
  return Math.ceil(nbr_chars /nbr_chars_by_sms);
}

export const to_moroccan_time = (date_time) => {
  var cur_time = new Date();
  var diff_mins = cur_time.getTimezoneOffset() + 60;
  if(diff_mins > 0){
    date_time = moment(date_time).add(diff_mins, "minutes");
  }
  else{
    date_time = moment(date_time).subtract(-diff_mins, "minutes");
  }
  
  return date_time.toDate();
}

export const convert_moy_anglo_to_moy = (moy_anglo, note_sur_anglo, cycles_notation_level) => {
  cycles_notation_level = cycles_notation_level || 10;
  if(moy_anglo && note_sur_anglo && cycles_notation_level && note_sur_anglo != cycles_notation_level){
    return parseInt(parseFloat(moy_anglo * cycles_notation_level) * 100 / (note_sur_anglo || cycles_notation_level)) / 100;
  }
  return moy_anglo;
}
export const BRITISH_3_NOTE_SUR = 50;
export const convert_moy_to_moy_anglo = (moy, note_sur_anglo, cycles_notation_level) => {
  cycles_notation_level = cycles_notation_level || 10;
  if(moy && note_sur_anglo && cycles_notation_level && note_sur_anglo != cycles_notation_level){
    return parseInt(parseFloat(moy * (note_sur_anglo || cycles_notation_level)) * 100 / (cycles_notation_level)) / 100;
  }
  return moy;
}

export const render_header_print = (school, sub_header, school_logo, idx) => {
  return <>
    {school.group_id == 340 ?
      <>
        <div className={'d-flex justify-content-between mb-1 header_slip ' + (idx > 0 ? "page-break" : "")}  
          style={{marginBottom: 50}}>
          <div>
            <img src={ib_elyakada_logo} style={{height: 50}}/>
          </div>
          <div>
            <img src={elyakada_logo} style={{height: 80}}/>
          </div>
        </div>
        {sub_header}
        <div className='d-flex p-1 rounded mt-4 mb-2' style={{marginTop: "1.5rem", marginBottom: "1rem"}}>
          <span className='db stl fsi'  style={{marginRight: 10}}>{this.scholar_year.name}</span>
          <span className='db stl fsi' > : </span>
          <span className='db stl stl2 tdu fsi'  style={{marginRight: 10, width: 120, direction: 'rtl'}}>{this.props.t("السنة الدراسية")}</span>
        </div>
      </>
      :
      <>
        <div className={'d-flex justify-content-between mb-1 header_slip ' + (idx > 0 ? "page-break" : "")}  
          style={{marginBottom: 50}}>
          <div>
            <img src={school_logo} style={{height: 50}}/>
          </div>
          <div>
            <div className="d-flex w-25">
              {school.name}
            </div>
          </div>
        </div>
        {sub_header}
        <div className='d-flex p-1 rounded mt-4 mb-2' style={{marginTop: "1.5rem", marginBottom: "1rem"}}>
          <span className='db stl fsi'  style={{marginRight: 10}}>{this.scholar_year.name}</span>
          <span className='db stl fsi' > : </span>
          <span className='db stl stl2 tdu fsi'  style={{marginRight: 10, width: 120, direction: 'rtl'}}>{this.props.t("السنة الدراسية")}</span>
        </div>
      </>
    }
  </>
}

export const to_local_time = (date_time) => {
  var cur_time = new Date();
  var diff_mins = cur_time.getTimezoneOffset() + 60;
  if(diff_mins < 0){
    date_time = moment(date_time).add(-diff_mins, "minutes");
  }
  else{
    date_time = moment(date_time).subtract(diff_mins, "minutes");
  }
  
  return date_time.toDate();
}

export const get_list_from_number = nbr => {
  var list = [];
  for (var i = 1; i <= nbr; i++) {
    list.push(i);
  }
  return list;
}

export const sections = [
  {title: 'Vie Scolaire', icon: images_menu.iconSectionVieScolaire, start_color: '#fdf0a580', end_color: '#f5de9280'},
  {title: 'Services', icon: images_menu.iconSectionInstallation, start_color: '#aceded80', end_color: '#97eeec80'},
  {title: 'Finances', icon: images_menu.iconSectionFincance, start_color: '#f2e1ca80', end_color: '#e3d1b580'},
  {title: 'Communication', icon: images_menu.iconSectionCommunication, start_color: '#f2cbca80', end_color: '#e3b5b580'},
  {title: 'Pédagogie', icon: images_menu.iconSectionPedagogie, start_color: '#cad3f280', end_color: '#b5c4e380'},
  {title: 'Autres', icon: images_menu.iconSectionOthers, start_color: '#d9caf280', end_color: '#c3b5e380'},
]

export const sections_professor = [
  {title: 'Vie Scolaire', icon: images_menu.iconSectionVieScolaire, start_color: '#fdf0a580', end_color: '#f5de9280'},
  {title: 'Pédagogie', icon: images_menu.iconSectionPedagogie, start_color: '#cad3f280', end_color: '#b5c4e380'},
  {title: 'Services', icon: images_menu.iconSectionInstallation, start_color: '#aceded80', end_color: '#97eeec80'},
  {title: 'Autres', icon: images_menu.iconSectionOthers, start_color: '#d9caf280', end_color: '#c3b5e380'},
]

export const sections_mobile = [
  {slug: 'professor', title: 'Enseignant', icon: images_menu.iconSectionVieScolaire, start_color: '#fdf0a580', end_color: '#f5de9280'},
  {slug: 'parent', title: 'parent', icon: images_menu.iconSectionPedagogie, start_color: '#cad3f280', end_color: '#b5c4e380'},
  {slug: 'student', title: 'élève', icon: images_menu.iconSectionInstallation, start_color: '#aceded80', end_color: '#97eeec80'},
]

export const menuItemsSchool = [
  {link:'/classes', slug: 'classes', title: 'Classes', className: 'iconClasses', icon: images_menu.iconMenuClasses, iconActive: images_menu.iconMenuClassesActive, id: 1, section: 0},
  {link:'/students', slug: 'students', title:'Students', className: 'iconStudents', icon: images_menu.iconMenuStudents, iconActive: images_menu.iconMenuStudentsActive, id: 2, section: 0},
  {link:'/parents', slug: 'parents', title:'Parents', className: 'iconStudents', icon: images_menu.iconMenuParents, iconActive: images_menu.iconMenuParentsActive, id: 3, section: 0},
  {link:'/professors', slug: 'professors', title:'Professors', className: 'iconProfessors', icon: images_menu.iconMenuProfessors, iconActive: images_menu.iconMenuProfessorsActive, id: 4, section: 0},
  {link:'/exercises', slug: 'exercises', title:'Exercices interactifs', className: 'iconExercices', icon: images_menu.iconMenuExercises, iconActive: images_menu.iconMenuExercisesActive, id: 5, section: 4}, 
  {link:'/GenerateWithAI', slug: 'Generateur AI', title:'AI', className: 'iconClasses', icon: images_menu.iconMenuExercises, iconActive: images_menu.iconMenuExercisesActive, id: 60, section: 4},
  {link:'/chatai', slug: 'chatai', title:'chat AI', className: 'iconExercices', icon: images_menu.iconMenuExercises, iconActive: images_menu.iconMenuExercisesActive, id: 61, section: 4}, 
  {link:'/kls_exercises', slug: 'kls_exercises', title: "Exercices Koolskools", className: 'iconExercices', icon: images_menu.iconMenuTextbook, iconActive: images_menu.iconMenuTextbookActive, id: 6, section: 4},
  {link:'/courses', slug: 'courses', title:'Courses', className: 'iconCourses', icon: images_menu.iconMenuLibraryNumeric, iconActive: images_menu.iconMenuLibraryNumericActive, id: 7, section: 4},
  {link:'/formations', slug: 'formations', title:'Formation', className: 'iconCourses', icon: images_menu.iconMenuFormation, iconActive: images_menu.iconMenuFormationActive, id: 8, section: 5},
  {link:'/zoom_cours', slug: 'zoom_cours', title:'Live Courses', className: 'iconCourses', icon: images_menu.iconMenuCoursesLive, iconActive: images_menu.iconMenuCoursesLiveActive, id: 10, section: 5},
  {link:'/challenges', slug: 'challenges', title:'Challenges', className: 'iconSettings', icon: images_menu.iconMenuChallenge, iconActive: images_menu.iconMenuChallengeActive, id: 11, section: 4},
  {link:'/activities', slug: 'activities', title:"Projets des élèves", className: 'iconCourses', icon: images_menu.iconMenuActivity, iconActive: images_menu.iconMenuActivityActive, id: 12, section: 5},
  {link:'/bibliotheque', slug: 'bibliotheque', title:'Bibliotheque Num', className: 'iconCourses', icon: images_menu.iconMenuLibrarySchool, iconActive: images_menu.iconMenuLibrarySchoolActive, id: 13, section: 1},
  {link:'/bibliotheque_phy', slug: 'bibliotheque_phy', title:'Bibliotheque Phys', className: 'iconCourses', icon: images_menu.iconMenuLibraryNumeric, iconActive: images_menu.iconMenuLibraryNumericActive, id: 14, section: 1},
  {link:'/statistics', slug: 'dashboard', title:'Dashboard', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 15, section: 5},
  {link:'/statistics_sanady', slug: 'dashboard_sanady', title:'Dashboard', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 15, section: 5},
  {link:'/payments', slug: 'payments', title:'Payments', className: 'iconStatistics', icon: images_menu.iconMenuPayment, iconActive: images_menu.iconMenuPaymentActive, id: 16, section: 2},
  {link:'/setting_discounts', slug: 'setting_discounts', title:'Paramètres des remises par élève', className: 'iconStatistics', icon: images_menu.iconMenuPayment, iconActive: images_menu.iconMenuPaymentActive, id: 63, section: 2},
  {link:'/conseil_classe', slug: 'conseil_classe', title:'Conseils de classe', className: 'iconStatistics', icon: images_menu.iconMenuConseilClasses, iconActive: images_menu.iconMenuConseilClassesActive, id: 17, section: 4},
  {link:'/billing', slug: 'bills', title:'Billing', className: 'iconBills', icon: images_menu.iconMenuInvoice, iconActive: images_menu.iconMenuInvoiceActive, id: 18, section: 2},
  {link:'/journal', slug: 'cahier_journal', title: getCycleName('notebook_journal'), className: 'iconCourses', icon: images_menu.iconMenuTextbook, iconActive: images_menu.iconMenuTextbookActive, id: 19, section: 4},
  {link:'/reclamations', slug: 'reclamations', title:'Reclamations', className: 'iconCourses', icon: images_menu.iconMenuComplaint, iconActive: images_menu.iconMenuComplaintActive, id: 20, section: 0},
  {link:'/classes_observations', slug: 'classes_observations', title: 'Grille d\'observation de classes', className: 'iconClasses', icon: images_menu.iconMenuClasses, iconActive: images_menu.iconMenuClassesActive, id: 54, section: 0},
  {link:'/assistants', slug: 'assistants', title:'Assistants', className: 'iconStudents', icon: images_menu.iconMenuAssistant, iconActive: images_menu.iconMenuAssistantActive, id: 21, section: 5},
  {link:'/inscriptions', slug: 'inscriptions', title:'Inscriptions', className: 'iconCourses', icon: images_menu.iconMenuPreinscription, iconActive: images_menu.iconMenuPreinscriptionActive, id: 22, section: 0},
  {link:'/social_network', slug: 'communication', title:'Communication', className: 'iconCourses', icon: images_menu.iconMenuCommunication, iconActive: images_menu.iconMenuCommunicationActive, id: 23, section: 3},
  {link:'/maintenance_monitorings', slug: 'maintenance_monitorings', title:'Suivi maintenance', className: 'iconCourses', icon: images_menu.iconMenuMaintenanceMonitorings, iconActive: images_menu.iconMenuMaintenanceMonitoringsActive, id: 56, section: 5},
  {link:'/scholar_activities', slug: 'scholar_activities', title:'Activité scolaires', className: 'iconCourses', icon: images_menu.iconMenuScholarActivities, iconActive: images_menu.iconMenuScholarActivitiesActive, id: 57, section: 5},
  {link:'/evaluation', slug: 'evaluations', title:'Grades/Marks', className: 'iconEvaluation', icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, id: 24, section: 4},
  {link:'/exam', slug: 'exams', title:'Evaluation', className: 'iconExam', icon: images_menu.iconMenuEvaluation, iconActive: images_menu.iconMenuEvaluationActive, id: 25, section: 4},
  {link:'/calendar', slug: 'calendar', title: 'Agenda des évènements', className: 'iconHoliday', icon: images_menu.iconMenuAgenda, iconActive: images_menu.iconMenuAgendaActive, id: 26, section: 3},
  {link:'/schedule', slug: 'schedule', title:'Schedule', className: 'iconSchedule', icon: images_menu.iconMenuSchedule, iconActive: images_menu.iconMenuScheduleActive, id: 27, section: 0},
  {link:'/absences', slug: 'call', title:'Student absences', className: 'iconAbsences', icon: images_menu.iconMenuAbsence, iconActive: images_menu.iconMenuAbsenceActive, id: 28, section: 0},
  {link:'/libraries', slug: 'libraries', title: "Stockage Documents", className: 'iconLibrary', icon: images_menu.iconMenuLibrary, iconActive: images_menu.iconMenuLibraryActive, id: 29, section: 5},
  {link:'/transport', slug: 'transport', title:'Transport', className: 'iconTransport', icon: images_menu.iconMenuTransport, iconActive: images_menu.iconMenuTransportActive, id: 30, section: 1},
  {link:'/internal_calls_visits', slug: 'internal_calls_visits', title:'Internal calls and visits', className: 'iconInternalCallsVisits', icon: images_menu.iconMenuVisit, iconActive: images_menu.iconMenuVisitActive, id: 32, section: 0},
  {link:'/cv_libraries', slug: 'cv_libraries', title:'CV-Thèque', className: 'iconInternalCallsVisits', icon: images_menu.iconMenuCvTheque, iconActive: images_menu.iconMenuCvThequeActive, id: 43, section: 0},
  {link:'/attestations', slug: 'attestations', title:'Attestations', className: 'iconStudents', icon: images_menu.iconMenuAttestation, iconActive: images_menu.iconMenuAttestationActive, id: 33, section: 5},
  {link:'/activities_prescolaire', slug: 'activities_prescolaire', title:'Activités Prescolaires', className: 'iconStudents', icon: images_menu.iconMenuActivityParascolaire, iconActive: images_menu.iconMenuActivityParascolaireActive, id: 34, section: 5},
  {link:'/cantine', slug: 'cantine', title:'Cantine/Garde/Transport', className: 'iconCantine', icon: images_menu.iconMenuCantine, iconActive: images_menu.iconMenuCantineActive, id: 35, section: 1},
  {link:'/cantine_menues', slug: 'cantine_menues', title:'Canteen menus', className: 'iconCantine', icon: images_menu.iconMenuCantineMenu, iconActive: images_menu.iconMenuCantineMenuActive, id: 60, section: 1},
  {link:'/purchases', slug: 'purchases', title:'Purchases', className: 'iconMenuNote', icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, id: 63, section: 5},
  {link:'/purchase_orders', slug: 'purchase_orders', title:'Purchase orders', className: 'iconPurchaseOrder', icon: images_menu.iconMenuCommand, iconActive: images_menu.iconMenuCommandActive, id: 36, section: 2},
  {link:'/activities_classes', slug: 'extracurricular_activity', title:'Extracurricular activity', className: 'iconClasses', icon: images_menu.iconMenuProjetEducatif, iconActive: images_menu.iconMenuProjetEducatifActive, id: 37, section: 4},
  {link:'/galleries', slug: 'galleries', title:'Gallery', className: 'iconGallery', icon: images_menu.iconMenuGallery, iconActive: images_menu.iconMenuGalleryActive, id: 38, section: 3}, 
  {link:'/transmissions', slug: 'transmissions', title:'Transmission', className: 'iconTransmission', icon: images_menu.iconMenuTransmission, iconActive: images_menu.iconMenuTransmissionActive, id: 39, section: 3},
  {link:'/messagerie', slug: 'messagerie', title:'Messagerie', className: 'iconCourses', icon: images_menu.iconMenuMessages, iconActive: images_menu.iconMenuMessagesActive, id: 40, section: 3},
  {link:'/email', slug: 'email', title:'Email', className: 'iconCourses', icon: images_menu.iconMenuMessages, iconActive: images_menu.iconMenuMessagesActive, id: 69, section: 3},
  {link:'/sms', slug: 'left_menu_sms', title:'SMS', className: 'iconSMS', icon: images_menu.iconMenuSms, iconActive: images_menu.iconMenuSmsActive, id: 42, section: 3},
  {link:'/classes_subjects_exams_calendar', slug: 'classes_exams_calendar', title:'Exams calendar', className: 'iconSchedule', icon: images_menu.iconMenuCalendarControl, iconActive: images_menu.iconMenuCalendarControlActive, id: 41, section: 0},
  {link:'/students_recovery', slug: 'students_outing', title:'Sortie des élèves', className: 'iconStudents', icon: images_menu.iconMenuStudents, id: 44, section: 5},
  {link:'/pos', slug: 'pos', title:'Shop', className: 'iconStudents', icon: images_menu.iconMenuLostObject, iconActive: images_menu.iconMenuLostObjectActive, id: 70, section: 5},
  {link:'/activities_kids', slug: 'activities_kids', title: 'Activités Maternelle', className: 'iconStudents', icon: images_menu.iconMenuActivity, iconActive: images_menu.iconMenuActivityActive, id: 45, section: 3},
  {link:'/extra_scolaire_activities', slug: 'extra_scolaire_activities', title: "Extracurricular activities", className: 'iconStudents', icon: images_menu.iconMenuActivity, iconActive: images_menu.iconMenuActivityActive, id: 51, section: 1},
  {link:'/annual_distribution', slug: 'annual_distribution', title:'Weekly plan', className: 'iconStudents', icon: images_menu.iconMenuStudents, id: 46, section: 4},
  {link:'/document_printing', slug: 'document_printing', title:'Impression', className: 'iconStudents', icon: images_menu.iconMenuStudents, id: 47, section: 0},
  {link:'/projects', slug: 'projects', title: 'Projects', className: 'iconClasses', icon: images_menu.iconMenuProjects, iconActive: images_menu.iconMenuProjectsActive, id: 58, section: 5},
  {link:'/areas_learnings', slug: 'areas_learnings', title:"Domaines d'apprentissage", className: 'iconStudents', icon: images_menu.iconMenuStudents, id: 48, section: 5},
  {link:'/connection_tracking', slug: 'connection_tracking', title:'Connection tracking', className: 'iconStatistics', icon: images_menu.iconMenuTracking, iconActive: images_menu.iconMenuTrackingActive, id: 49, section: 5},
  {link:'/homework_follow_up', slug: 'homework_follow_up', title:'Homework follow-up', className: 'iconHomeworkFollowUp', icon: images_menu.iconMenuActivityParascolaireActive, id: 50, section: 4},
  {link:'/reporting', slug: 'reporting', title:'Reports and Lists', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 52, section: 5},
  {link:'/evals_calendar', slug: 'evals_calendar', title:'Calendrier des évaluations', className: 'iconSchedule', icon: images_menu.iconMenuCalendarControl, iconActive: images_menu.iconMenuCalendarControlActive, id: 55, section: 5},
  {link:'/surveys', slug: 'surveys', title:'Surveys', className: 'iconSurveys', icon: images_menu.iconMenuSurvey, iconActive: images_menu.iconMenuSurveyActive, id: 53, section: 3},
  {link:'/losts_objects', slug: 'losts_objects', title:'LostsObjects', className: 'iconLostObject', icon: images_menu.iconMenuLostObject, iconActive: images_menu.iconMenuLostObjectActive, id: 54, section: 0},
  {link:'/resources', slug: 'resources', title: 'Resources', className: 'iconClasses', icon: images_menu.iconMenuProjects, iconActive: images_menu.iconMenuProjectsActive, id: 59, section: 5},
  {link:'/whatsapp', slug: 'whatsapp', title:'Whatsapp', className: 'iconWhatsApp', icon: images_menu.iconMenuWhatsApp, iconActive: images_menu.iconMenuWhatsAppActive, id: 60, section: 3},
  {link:'/critical_bulletin', slug: 'critical_bulletin', title:'Bulletin critérié', className: 'iconMenuNote', icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, id: 61, section: 4},
  {link:'/document_request', slug: 'document_request', title:'Demande', className: 'iconLibrary', icon: images_menu.iconMenuLibrary, iconActive: images_menu.iconMenuLibraryActive, id: 66, section: 5},
  {link:'/clocking', slug: 'clocking', title:'Pointage', className: 'iconLibrary', icon: images_menu.iconMenuLibrary, iconActive: images_menu.iconMenuLibraryActive, id: 67, section: 5},
  {link:'/inventory_management', slug: 'inventory_management', title:'Gestion des stocks', className: 'iconLibrary', icon: images_menu.iconMenuLibrary, iconActive: images_menu.iconMenuLibraryActive, id: 68, section: 5},
  {link:'/behaviors', slug: 'behavior', title:'Discipline', className: 'iconMenuNote', icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, id: 62, section: 0},
  {link:'/agenda_personnel', slug: 'agenda_personnel', title:'Agenda personnel', className: 'iconMenuNote', icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, id: 64, section: 0},
  {link:'/coffre', slug: 'coffres', title:'Coffre', className: 'iconStatistics', icon: images_menu.iconMenuPayment, iconActive: images_menu.iconMenuPaymentActive, id: 65, section: 2},
  {link:'/wonde', slug: 'wonde', title:'Wonde Sync', className: 'iconStatistics', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 69, section: 5},
  {link:'/settings', slug: 'settings', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/levels', slug: 'settings_levels_subjects', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/competencies', slug: 'settings_evaluations', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/classrooms', slug: 'settings_classroom', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/periods', slug: 'settings_period', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/payments', slug: 'settings_payments', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/reclamations', slug: 'settings_reclamations', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/behavior', slug: 'settings_behavior', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/staff', slug: 'settings_staff', title:'Staffs', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/holidays', slug: 'settings_holidays', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/absences', slug: 'settings_absences', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},
  {link:'/settings/incidents', slug: 'settings_incidents', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuEvaluationActive, id: 31, section: 5},
  {link:'/settings/referentiel', slug: 'settings_referentiel', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},  
  {link:'/settings/coursvalidation', slug: 'settings_schoolvalidation', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5},  
  {link:'/settings/settings_staff', slug: 'settings_staff', title:'Settings', className: 'iconSettings', icon: images_menu.iconMenuParametre, iconActive: images_menu.iconMenuParametreActive, id: 31, section: 5}
]
export const menuItemsSchoolParentSanadi = [
  {link:'/reporting', slug: 'reporting', title:'Reports and Lists', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 52, section: 5},
  // {link:'/statistics_sanady', slug: 'dashboard_sanady', title:'Dashboard', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 15, section: 5},
]

export const menuItemsProfessor = [
  {url: "/professor/classes", slug: 'classes',label: "Classes", icon: images_menu.iconMenuClasses, iconActive: images_menu.iconMenuClassesActive, className: "iconClasses", section: 0, id: 1},
  {url: "/professor/statistics", slug: 'statistics',label: "Dashboard", icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, className: "iconStatistics", section: 3, id: 2},
  {url: "/professor/students", slug: 'students',label: "Students", icon: images_menu.iconMenuStudents, iconActive: images_menu.iconMenuStudentsActive, className: "iconStudents", section: 0, id: 3},
  {url: "/professor/exercises", slug: 'exercises',label: 'Exercices interactifs', icon: images_menu.iconMenuExercises, iconActive: images_menu.iconMenuExercisesActive, className: "iconExercices", section: 1, id: 4},
  {url: "/professor/courses", slug: 'courses',label: "Courses", icon: images_menu.iconMenuLibraryNumeric, iconActive: images_menu.iconMenuLibraryNumericActive, className: "iconCourses", section: 1, id: 5},
  {url: "/professor/activities_prescolaire", slug: 'activities_prescolaire',label: "Activités Prescolaires", icon: images_menu.iconMenuActivityParascolaire, iconActive: images_menu.iconMenuActivityParascolaireActive, className: "iconStudents", section: 3, id: 6},
  {url: "/professor/formations", slug: 'formations',label: "Formation", icon: images_menu.iconMenuFormation, iconActive: images_menu.iconMenuFormationActive, className: "iconCourses", section: 3, id: 7},
  {url: "/professor/zoom_cours", slug: 'zoom_cours',label: "Live Courses", icon: images_menu.iconMenuCoursesLive, iconActive: images_menu.iconMenuCoursesLiveActive, className: "iconCourses", section: 3, id: 8},
  {url: "/professor/schedule", slug: 'schedule',label: "Emploi du temps", icon: images_menu.iconMenuSchedule, iconActive: images_menu.iconMenuScheduleActive, className: "iconSchedule", section: 0, id: 9},
  {url: "/professor/activities", slug: 'activities',label: "Projets des élèves", icon: images_menu.iconMenuActivity, iconActive: images_menu.iconMenuActivityActive, className: "iconCourses", section: 3, id: 10},
  {url: "/professor/bibliotheque", slug: 'bibliotheque',label: "Bibliotheque", icon: images_menu.iconMenuLibrarySchool, iconActive: images_menu.iconMenuLibrarySchoolActive, className: "iconCourses", section: 3, id: 11},
  {url: "/professor/challenges", slug: 'challenges',label: "Challenges", icon: images_menu.iconMenuChallenge, iconActive: images_menu.iconMenuChallengeActive, className: "iconChallenge", section: 3, id: 12},
  {url: "/professor/evaluation", slug: 'evaluation',label: "Grades/Marks", icon: images_menu.iconMenuNote, iconActive: images_menu.iconMenuNoteActive, className: "iconEvaluation", section: 1, id: 13},
  {url: "/professor/social_network", slug: 'social_network',label: "Communication", icon: images_menu.iconMenuCommunication, iconActive: images_menu.iconMenuCommunicationActive, className: "iconCourses", section: 3, id: 14},
  {url: "/professor/exam", slug: 'exam',label: "Evaluation", icon: images_menu.iconMenuEvaluation, iconActive: images_menu.iconMenuEvaluationActive, className: "iconExam", section: 1, id: 15},
  {url: "/professor/classes_subjects_exams_calendar", slug: 'classes_subjects_exams_calendar',label: "Exams calendar", icon: images_menu.iconMenuCalendarControl, iconActive: images_menu.iconMenuCalendarControlActive, className: "iconSchedule", section: 3, id: 16},
  {url: "/professor/absences" , slug: 'absences', label: "Student absences", icon: images_menu.iconMenuAbsence, iconActive: images_menu.iconMenuAbsenceActive, className: "iconAbsences", section: 0, id: 17},
  {url: "/professor/messagerie",slug: 'messagerie',  label: 'Messagerie', icon: images_menu.iconMenuMessages, iconActive: images_menu.iconMenuMessagesActive, className: "iconCourses", section: 3, id: 18},
  // {url: "/professor/email",slug: 'email',  label: 'Email', icon: images_menu.iconMenuMessages, iconActive: images_menu.iconMenuMessagesActive, className: "iconCourses", section: 3, id: 60},
  {url: "/professor/libraries", slug: 'libraries', label: 'Drive', icon: images_menu.iconMenuLibrary, iconActive: images_menu.iconMenuLibraryActive, className: "iconLibrary", section: 3, id: 19},
  {url: "/professor/journal", slug: 'journal', label: getCycleName('notebook_journal'), icon: images_menu.iconMenuTextbook, iconActive: images_menu.iconMenuTextbookActive, className: "iconCourses", section: 1, id: 20},
  {url: "/professor/activities_classes", slug: 'activities_classes', label:'Extracurricular activity', icon: images_menu.iconMenuProjetEducatif, iconActive: images_menu.iconMenuProjetEducatifActive, className: "iconClasses", section: 1, id: 21},
  {url: "/professor/galleries", slug: 'galleries', label: "Gallery", icon: images_menu.iconMenuGallery, iconActive: images_menu.iconMenuGalleryActive, className: "iconGalleries", section: 3, id: 22},
  {url: "/professor/transmissions", slug: 'transmissions', label: "Transmission", icon: images_menu.iconMenuTransmission, iconActive: images_menu.iconMenuTransmissionActive, className: "iconTransmission", section: 3, id: 23},
  {url: "/professor/students_recovery", slug: 'students_recovery', label: "Sortie des élèves", icon: images_menu.iconMenuStudents, className: "iconStudents", section: 3, id: 24},
  {url: "/professor/annual_distribution", slug: 'annual_distribution', label: 'Weekly plan', icon: images_menu.iconMenuStudents, className: "iconStudents", section: 3, id: 25},
  {url: "/professor/document_printing", slug: 'document_printing', label: 'Impression', icon: images_menu.iconMenuStudents, className: "iconStudents", section: 3, id: 26},
  {url:'/professor/critical_bulletin', slug: 'critical_bulletin', label:'Bulletin critérié', icon: images_menu.iconMenuNote, className: 'iconMenuNote', id: 61, section: 1},
  {url:'/professor/agenda_personnel', slug: 'agenda_personnel', label:'Agenda personnel', icon: images_menu.iconMenuNote, className: 'iconMenuNote', id: 64, section: 0},
  {url: "/professor/projects", slug: 'projects',label: "Projects", icon: images_menu.iconMenuProjects, iconActive: images_menu.iconMenuProjectsActive, className: "iconClasses", section: 3, id: 29},
  {url: "/professor/extra_scolaire_activities", slug: 'extra_scolaire_activities', label: 'Extracurricular activities', icon: images_menu.iconMenuActivity, className: "iconStudents", section: 2, id: 27},
  {url: "/professor/student_outing", slug: 'student_outing', label: 'Sortie élève', icon: images_menu.iconMenuActivity, className: "iconStudents", section: 2, id: 28},
  {url: "/professor/resources", slug: 'resources', label: 'Resources', icon: images_menu.iconMenuClasses, iconActive: images_menu.iconMenuClassesActive, className: "iconClasses", section: 3, id: 59},
  {url:'/professor/reporting', slug: 'reporting', label:'Reports and Lists', className: 'iconStatistics', icon: images_menu.iconMenuDashboard, iconActive: images_menu.iconMenuDashboardActive, id: 52, section: 3},
]

export const menuItemsProfessorMobile = [
  {slug: 'post', label: 'Communication', icon: images_menu.iconMenuCommunication},
  {slug: 'textbook', label: 'Homeworks', icon: images_menu.iconMenuTextbook},
  {slug: 'course', label: 'Cours', icon: images_menu.iconMenuLibraryNumeric},
  {slug: 'notes', label: 'Grades/Marks', icon: images_menu.iconMenuNote},
  {slug: 'seance', label: 'Emploi du temps', icon: images_menu.iconMenuSchedule},
  {slug: 'journal', label: 'Cahier journal', icon: images_menu.iconMenuSchedule},
  {slug: 'absence', label: 'Absences', icon: images_menu.iconMenuAbsence},
  {slug: 'gallery', label: 'Galerie', icon: images_menu.iconMenuGallery},
  {slug: 'inbox', label: 'Messages', icon: images_menu.iconMenuMessages},
  {slug: 'tarl', label: 'TARL', icon: images_menu.iconMenuNote},
  {slug: 'competency', label: 'Skills', icon: images_menu.iconMenuNote},
  {slug: 'resource', label: 'Resources', icon: images_menu.iconMenuLostObject},
  {slug: 'discipline', label: 'Discipline', icon: images_menu.iconMenuLostObject},
  {slug: 'transmission', label: 'Transmission', icon: images_menu.iconMenuTransmission},
  {slug: 'activity', label: 'Activités Maternelle', icon: images_menu.iconMenuActivity}
]

export const menuItemsParentMobile = [
  {slug: 'post', label: 'Accueil', icon: images_menu.iconMenuCommunication},
  {slug: 'textbook', label: 'Homeworks', icon: images_menu.iconMenuTextbook},
  {slug: 'seance', label: 'Emploi du temps', icon: images_menu.iconMenuSchedule},
  {slug: 'absence', label: 'Absences & Retards', icon: images_menu.iconMenuAbsence},
  {slug: 'notes', label: 'Grades/Marks', icon: images_menu.iconMenuNote},
  {slug: 'course', label: 'Cours', icon: images_menu.iconMenuLibraryNumeric},
  {slug: 'exam_calendar', label: 'Calendrier des contrôles', icon: images_menu.iconMenuCalendarControl},
  {slug: 'event', label: 'Agenda', icon: images_menu.iconMenuAgenda},
  {slug: 'gallery', label: 'Galerie', icon: images_menu.iconMenuGallery},
  {slug: 'transmission', label: 'Transmission', icon: images_menu.iconMenuTransmission},
  {slug: 'payment', label: 'Paiements', icon: images_menu.iconMenuPayment},
  {slug: 'information', label: 'Information école', icon: images_menu.iconMenuParametre},
  {slug: 'inbox', label: 'Messages', icon: images_menu.iconMenuMessages},
  {slug: 'infirmary', label: 'Infirmerie', icon: images_menu.iconMenuComplaint},
  {slug: 'competency', label: 'Skills', icon: images_menu.iconMenuNote},
  {slug: 'survey', label: 'Sondages', icon: images.iconMenuSondageActive},
  {slug: 'lost_object', label: 'LostsObjects', icon: images_menu.iconMenuLostObject},
  {slug: 'resource', label: 'Ressources', icon: images_menu.iconMenuLostObject},
  {slug: 'cantine', label: 'Menus de la cantine', icon: images_menu.iconMenuCantineMenu},
  // {slug: 'activity', label: 'Activities', icon: images_menu.iconMenuTextbook},
  {slug: 'discipline', label: 'Discipline', icon: images_menu.iconMenuLostObject},
  {slug: 'holiday', label: 'Vacances scolaires', icon: images_menu.iconMenuAgenda},
  {slug: 'document', label: 'Demande de document', icon: images_menu.iconMenuParametre},
  {slug: 'localisation', label: 'Sortie scolaire', icon: images_menu.iconMenuParametre},
  {slug: 'activity', label: 'Activités Maternelle', icon: images_menu.iconMenuActivity},
  {slug: 'childs_info', label: 'Fiche santé', icon: images_menu.iconMenuParametre}
]

export const menuItemsStudentMobile = [
  {slug: 'home', label: 'Accueil', icon: images_menu.iconMenuDashboard},
  {slug: 'seance', label: 'Emploi du temps', icon: images_menu.iconMenuSchedule},
  {slug: 'textbook', label: 'Homeworks', icon: images_menu.iconMenuTextbook},
  {slug: 'course', label: 'Cours', icon: images_menu.iconMenuLibraryNumeric},
  {slug: 'notes', label: 'Grades/Marks', icon: images_menu.iconMenuNote},
  {slug: 'post', label: 'Communication', icon: images_menu.iconMenuCommunication},
  {slug: 'challenge', label: 'Challenge', icon: images_menu.iconMenuChallenge},
  {slug: 'event', label: 'Agenda', icon: images_menu.iconMenuAgenda},
  {slug: 'exam_calendar', label: 'Calendrier des contrôles', icon: images_menu.iconMenuCalendarControl},
  {slug: 'inbox', label: 'Messages', icon: images_menu.iconMenuMessages},
  {slug: 'survey', label: 'Sondages', icon: images.iconMenuSondageActive},
  {slug: 'lost_object', label: 'LostsObjects', icon: images_menu.iconMenuLostObject},
  {slug: 'resource', label: 'Ressources', icon: images_menu.iconMenuLostObject},
  {slug: 'cantine', label: 'Menus de la cantine', icon: images_menu.iconMenuCantineMenu},
  {slug: 'holiday', label: 'Vacances scolaires', icon: images_menu.iconMenuAgenda},
  {slug: 'agenda', label: 'Agenda personnel', icon: images_menu.iconMenuAgenda},
]

export const render_boolean = (value, with_parentheses, only_on_char, t) => {
  t = t || ((s) => s);
  let res = [true, 1, "1"].indexOf(value) !== -1 ? (only_on_char ? "O" : 'Oui') : [false, 0, "0"].indexOf(value) !== -1 ? (only_on_char ? "N" :'Non') : "";
  return with_parentheses && res ? `(${res}) ` : res;
}


export const getSubjectsFromLevels = (levels, levels_ids) => {
  var all_subjects =  [],
    all_levels = levels || get('levels') || [];
  levels_ids = levels_ids || all_levels.map(level => {
    return level.level_id
  })
  if(all_levels.length){
    levels_ids.forEach(level_id => {
      var level = all_levels.filter(level => {
        return level.level_id == level_id
      })[0];
      if('subjects_details' in level)
        all_subjects = all_subjects.concat(level.subjects_details.map(subjectD => {
          return subjectD.subject
        }).filter(subject => {
          return !all_subjects.filter(sub => {
            return sub.subject_id == subject.subject_id
          }).length
        }))
      else
        all_subjects = all_subjects.concat(level.subjects.filter(subject => {
          return !all_subjects.filter(sub => {
            return sub.subject_id == subject.subject_id
          }).length
        }))
    })
  }

  return all_subjects;
}

export const stylePDF = `
  &.dialogExportViewer2{
    width: 794px;
    padding: 0cm;
    color: #000;
    .export_content{
      &.print_viewer{
        padding-bottom: 0 !important!
        .payments_students{
          padding-bottom: 0 !important!
          padding-top: 0 !important!
        }
      }
      // height: 100%;
      width: 100%;
      // border: 2px solid red;
      .payments_students{
        // height: calc(100% - 180px);
        margin: 0px;
        &::-webkit-scrollbar-track{
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          background-color: #F5F5F5;
          border-radius: 5px;
          position: absolute;
          right: -50; /* Position the scrollbar on the right of the element*/
        }
        &::-webkit-scrollbar{
          width: 10px;
          height: 10px;
          background-color: #F5F5F5;
          border-radius: 5px;
          position: absolute;
          right: -50; /* Position the scrollbar on the right of the element*/
        }
        &::-webkit-scrollbar-thumb{
          background-color: #3eb6ad;
          border-radius: 5px;
          position: absolute;
          right: -50; /* Position the scrollbar on the right of the element*/
        }
        .header_slip{
          display: flex;
          justify-content: space-between;
          width: 100%;
          // border: 2px solid green;
          >div{
            // border: 2px solid blue;
              /*border:1px solid #000;*/
              height:100px;
              width:300px;
              padding:5px;
              display:flex;
              justify-content:center;
              align-items:center;
              font-weight: bold;
              &:first-child{
                justify-content:flex-start;
              }
              img{
                max-width:100%;
                max-height:100%
              }
          }
        }
        .header_slip_title{
          border: 2px solid #000;
          padding: 10px;
          margin: 10px 0px;
          text-align: center;
          font-weight: bold;
        }
        &.viewer{
          .header_slip{
            >div{
              height:150px;
            }
          }
          .header_slip_title{
            margin: 10px auto;
            width: max-content;
          }
          .table_payments{
            .header_slip_title{
              margin: 10px auto;
              width: max-content;
            }
            .header_line{
              background-color: #b5c4e3;
              td:not(.spacer_td), th{
                background-image: none;
                background-color: #b5c4e3;
                font-size: 12px;
                font-weight: 600;
              }
            }
            th, td{
              font-size: 12px;
              color: #000;
            }
          }
        }
        &.students_by_new_registration{
          .header_slip_title{
            padding: 10px 20px !important;
            color: black !important;
            border-radius: 6px;
          }
        }
      }
      .levels_remainings_places{
        .payments_students{
          td{
            border-radius: 0 !important;
            text-wrap: wrap !important;
            padding: 2px !important;
            border-color: #000 !important;
            height: auto !important;
            font-weight: bold !important;
            background-image: unset !important;
            font-size: 11px !important;
            line-height: 1 !important;
          }
          td.header_level{
            background-color: #6fa8dc !important;
            color: black !important;
            font-weight: bold !important;
            background-image: unset !important;
          }
          td.cycle_total_td{
            background-color: #073763 !important;
            color: white !important;
            font-weight: bold !important;
            background-image: unset !important;
          }
          .cycles_total td{
            background-color: #6fa8dc !important;
            color: white !important;
            font-weight: bold !important;
            background-image: unset !important;
          }
          .height4{
            td{
              padding: 5px !important;
              font-size: 13px !important;
            }
          }
          .height3{
            td{
              padding: 9px !important;
              font-size: 14px !important;
            }
          }
          .height2{
            td{
              padding: 11px !important;
              font-size: 15px !important;
            }
          }
          .height1{
            td{
              padding: 15px !important;
              font-size: 17px !important;
            }
          }
        }
        .students_list{
          width: 100% !important;
        }
        .header_slip{
          >div{
              height:100px !important;
              width:300px;
              padding:5px;
              display:flex;
              justify-content:center;
              align-items:center;
              font-weight: bold;
              &:first-child{
                justify-content:flex-start;
              }
              img{
                max-width:100%;
                max-height:100%
              }
          }
        }
      }
    }
    &.landscapePdf{
      width: 1100px;
    }
  }
  
  .export_content{
    height: calc(100% - 40px);
    padding-bottom: 40px;
    .payments_students{
      height: calc(100% - 166px);
      &.effectifs_students_by_project, &.effectifs_students_by_school, &.effectifs_students_by_cycle, &.effectifs_students_by_level, &.effectifs_students_by_classe{
        height: calc(100% - 100px) !important;
      }
      &::-webkit-scrollbar-track{
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
        border-radius: 5px;
        position: absolute;
          right: -50; /* Position the scrollbar on the right of the element*/
      }
      &::-webkit-scrollbar{
        width: 10px;
        height: 10px;
        background-color: #F5F5F5;
        border-radius: 5px;
        position: absolute;
        right: -50; /* Position the scrollbar on the right of the element*/
      }
      &::-webkit-scrollbar-thumb{
        background-color: #3eb6ad;
        border-radius: 5px;
        position: absolute;
          right: -50; /* Position the scrollbar on the right of the element*/
      }
      &.viewer{
        .students_list{
          height: 100%;
          width: 100%;
          background-color: rgb(245, 246, 250);
          margin: 18px 15px;
          border-radius: 8px;
          padding: 10px 5px;
          border-width: 1px;
          border-style: solid;
          border-color: rgb(209, 219, 226);
          border-image: initial;
          &.students_list2{
            flex: 1;
            width: max-content;
            min-width: 100%;
            margin: 0px;
            backdrop-filter: none;
            background-color: #FFF;
            border: 0px;
            border-radius: 0px;
            padding: 0px;
            .parent_body{
              border: 3px solid #000;
            }
            table{
              tr{
                th.checkbox_col, td.checkbox_col{
                  width: 10px;
                }
                &.header{
                  td:not(.spacer_td), th{
                    background-image: none;
                    background-color: #b5c4e3;
                    font-size: 12px;
                    font-weight: 600;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:first-child {
                      border-radius: 0px;
                      border-bottom-left-radius: 0px;
                    }
                    &:last-child {
                      border-right-width: 1px!important;
                      border-top-right-radius: 0px;
                      border-bottom-right-radius: 0px;
                    }
                  }
                }
                &.header2{
                  td{
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 1.45;
                    color: #6e6e6e;
                    height: 50px;
                    padding: 10px 5px;
                    background-color: white;
                    border-style: solid;
                    border-color: #e8e8e8;
                    border-image: initial;
                    border-width: 1px 0px 1px 1px;
                    width: auto;
                    white-space: nowrap;
                    padding: 2px;
                    &.header_level{
                      background-image: linear-gradient(to bottom, #cad3f2 3%, #b5c4e3 96%);
                      font-size: 10px;
                      font-weight: 600;
                      line-height: 1.64;
                      color: #202726;
                      &:first-child {
                        border-top-left-radius: 14px;
                        border-bottom-left-radius: 14px;
                      }
                      &:last-child {
                        border-right-width: 1px;
                        border-top-right-radius: 14px;
                        border-bottom-right-radius: 14px;
                      }
                    }
                  }
                }
                &.student:not(.spacer){
                  th{
                    background-image: none;
                    background-color: #b5c4e3;
                    font-size: 12px;
                    font-weight: 600;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:first-child {
                      border-radius: 0px;
                      border-bottom-left-radius: 0px;
                    }
                    &:last-child {
                      border-right-width: 1px!important;
                      border-top-right-radius: 0px;
                      border-bottom-right-radius: 0px;
                    }
                  }
                  td:not(.spacer_td){
                    border-radius: 0px;
                    font-size: 11px;
                    font-weight: 500;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:last-child {
                      border-right-width: 1px!important;
                    }
                  }
                }
              }
            }
          }
          &.students_list2{
            flex: 1;
            width: max-content;
            min-width: 100%;
            margin: 0px;
            backdrop-filter: none;
            background-color: #FFF;
            border: 0px;
            border-radius: 0px;
            padding: 0px;
            .parent_body{
              border: 3px solid #000;
            }
            table{
              tr{
                th.checkbox_col, td.checkbox_col{
                  width: 10px;
                }
                &.header{
                  td:not(.spacer_td), th{
                    background-image: none;
                    background-color: #b5c4e3;
                    font-size: 14px;
                    font-weight: 600;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:first-child {
                      border-radius: 0px;
                      border-bottom-left-radius: 0px;
                    }
                    &:last-child {
                      border-right-width: 1px!important;
                      border-top-right-radius: 0px;
                      border-bottom-right-radius: 0px;
                    }
                  }
                }
                &.header2{
                  td{
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.45;
                    color: #6e6e6e;
                    height: 50px;
                    padding: 10px 5px;
                    background-color: white;
                    border-style: solid;
                    border-color: #e8e8e8;
                    border-image: initial;
                    border-width: 1px 0px 1px 1px;
                    width: auto;
                    white-space: nowrap;
                    padding: 2px;
                    &.header_level{
                      background-image: linear-gradient(to bottom, #cad3f2 3%, #b5c4e3 96%);
                      font-size: 14px;
                      font-weight: 600;
                      line-height: 1.64;
                      color: #202726;
                      &:first-child {
                        border-top-left-radius: 14px;
                        border-bottom-left-radius: 14px;
                      }
                      &:last-child {
                        border-right-width: 1px;
                        border-top-right-radius: 14px;
                        border-bottom-right-radius: 14px;
                      }
                    }
                  }
                }
                &.student:not(.spacer){
                  th{
                    background-image: none;
                    background-color: #b5c4e3;
                    font-size: 14px;
                    font-weight: 600;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:first-child {
                      border-radius: 0px;
                      border-bottom-left-radius: 0px;
                    }
                    &:last-child {
                      border-right-width: 1px!important;
                      border-top-right-radius: 0px;
                      border-bottom-right-radius: 0px;
                    }
                  }
                  td:not(.spacer_td){
                    border-radius: 0px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    padding: 2px;
                    &:last-child {
                      border-right-width: 1px!important;
                    }
                  }
                }
              }
            }
          }
          &.students_tarl_notes{
            width: max-content;
            min-width: 100%;
            margin: 0px;
            backdrop-filter: none;
            background-color: #FFF;
            border: 0px;
            border-radius: 0px;
            padding: 0px;
            table{
              tr{
                &.header{
                  td:not(.spacer_td), th{
                    background-image: none;
                    background-color: #b5c4e3;
                    font-size: 13px;
                    font-weight: 600;
                    color: #000;
                    width: auto;
                    white-space: nowrap;
                    border-color: #000;
                    height: 30px;
                    &:first-child {
                      border-radius: 0px;
                      border-bottom-left-radius: 0px;
                    }
                    &:last-child {
                      border-right-width: 0px;
                      border-top-right-radius: 10px;
                      border-bottom-right-radius: 10px;
                    }
                  }
                }
              }
            }
          }
          &.cantine_garde{
            overflow: overlay !important;
            // min-width: 100%;
            // width: max-content;
          }
          table{
            margin: auto;
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0px;
            border: 1px solid #000;
            tr{
              text-align: center;
              td:not(.spacer_td){
                // border-left: 1px solid black;
                // border-top: 1px solid black;
                width: 6%;
                &.large{
                  width: 6.46%
                }
                &.name{
                  width: calc(16% - 20px);
                }
                padding: 3px;
                font-size: 10px;
              }
              &.header{
                font-weight: bold;
                td:not(.spacer_td), th{
                  padding-bottom: 20px;
                }
              }
              &.spacer{
                height: 10px;
              }
              &.student:not(.spacer), &.header{
                td:not(.spacer_td), th{
                  background-color: rgb(255, 255, 255);
                  height: auto;
                  border-style: solid;
                  border-color: rgb(232, 232, 232);
                  border-image: initial;
                  border-width: 1px 0px 1px 1px;
                  padding: 10px;
                  &:first-child {
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                  }
                  &:last-child {
                    border-right-width: 0px;
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                  }
                  &.gray{
                    background: #F5F5F5;
                  }
                  &.red{
                    background: #FF0000;
                  }
                  &.greeen{
                    background: #00FF00;
                  }
                  &.gray2{
                    background: gray;
                  }
                  &.p_em{
                    max-width: 100px;
                    word-break: break-all;
                  }
                }
              }
              td.spacer_td{
                width: 10px;
                border-left: 1px;
                border-left-style: solid;
                border-left-color: #e8e8e8;
              }
              td.name_ {
                background-color: #f5f6fa !important;
            }
              td.name.header_level {
                background-color: #e8e8e8 !important;
              }
            }
            &.mobile{

              margin: auto;
              width: 100%;
              border-collapse: separate;
              border-spacing: 0px;
              tr{
                text-align: center;
                td:not(.spacer_td){
                  // border-left: 1px solid black;
                  // border-top: 1px solid black;
                  width: 25%;
                  &.large{
                    width: 25%
                  }
                  &.name{
                    width: calc(50% - 10px);
                  }
                }
              }
            }
          }
          &.no_scroll{
            overflow: unset;
          }
        }
      }
      .students_list{
        height: 100%;
        width: 100%;
        background-color: rgb(245, 246, 250);
        margin: 18px 15px;
        border-radius: 16px;
        padding: 10px 5px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(209, 219, 226);
        border-image: initial;
        &.students_list2{
          flex: 1;
          width: max-content;
          min-width: 100%;
          margin: 0px;
          backdrop-filter: blur(8px);
          background-color: rgba(222, 230, 234, 0.64);
          table{
            tr{
              th.checkbox_col, td.checkbox_col{
                width: 10px;
              }
              &.header{
                td:not(.spacer_td), th{
                  background-image: linear-gradient(to bottom, #cad3f2 3%, #b5c4e3 96%);
                  font-size: 13px;
                  font-weight: 600;
                  line-height: 1.64;
                  color: #202726;
                  width: auto;
                  white-space: nowrap;
                  &:first-child {
                    border-top-left-radius: 14px;
                    border-bottom-left-radius: 14px;
                  }
                  &:last-child {
                    border-right-width: 1px;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                  }
                }
              }
              &.header2{
                td{
                  border-radius: 6px;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 1.45;
                  color: #6e6e6e;
                  height: 50px;
                  padding: 10px 5px;
                  background-color: white;
                  border-style: solid;
                  border-color: #e8e8e8;
                  border-image: initial;
                  border-width: 1px 0px 1px 1px;
                  width: auto;
                  white-space: nowrap;
                  &.header_level{
                    background-image: linear-gradient(to bottom, #cad3f2 3%, #b5c4e3 96%);
                    font-size: 11px;
                    font-weight: 600;
                    line-height: 1.64;
                    color: #202726;
                    &:first-child {
                      border-top-left-radius: 14px;
                      border-bottom-left-radius: 14px;
                    }
                    &:last-child {
                      border-right-width: 1px;
                      border-top-right-radius: 14px;
                      border-bottom-right-radius: 14px;
                    }
                  }
                }
              }
              &.header_s_t{
                td:not(.spacer_td), th{
                  height: 30px;
                  padding: 5px;
                  &:first-child {
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                  }
                  &:last-child {
                    border-right-width: 1px;
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                  }
                }
              }
              &.student:not(.spacer){
                td:not(.spacer_td){
                  border-radius: 6px;
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 1.45;
                  color: #6e6e6e;
                  width: auto;
                  white-space: nowrap;
                }
              }
            }
          }
        }
        &.students_tarl_notes{
          table{
            tr{
              &.header{
                td:not(.spacer_td), th{
                  height: 30px;
                  padding: 5px;
                  &:first-child {
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                  }
                  &:last-child {
                    border-right-width: 1px;
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                  }
                }
              }
            }
          }
        }
        &.cantine_garde{
          overflow: overlay !important;
          // min-width: 100%;
          // width: max-content;
        }
        table{
          margin: auto;
          width: 100%;
          border-collapse: separate;
          border-spacing: 1px;
          tr{
            text-align: center;
            td:not(.spacer_td){
              // border-left: 1px solid black;
              // border-top: 1px solid black;
              width: 6%;
              &.large{
                width: 6.46%
              }
              &.name{
                width: calc(16% - 20px);
              }
              padding: 3px;
              font-size: 10px;
            }
            &.header{
              font-weight: bold;
              td:not(.spacer_td), th{
                padding-bottom: 20px;
              }
            }
            &.spacer{
              height: 10px;
            }
            &.student:not(.spacer), &.header{
              td:not(.spacer_td), th{
                background-color: rgb(255, 255, 255);
                height: 50px;
                border-style: solid;
                border-color: rgb(232, 232, 232);
                border-image: initial;
                border-width: 1px 0px 1px 1px;
                padding: 10px;
                &:first-child {
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                }
                &:last-child {
                  border-right-width: 1px;
                  border-top-right-radius: 4px;
                  border-bottom-right-radius: 4px;
                }
                &.gray{
                  background: #F5F5F5;
                }
                &.red{
                  background: #FF0000;
                }
                &.greeen{
                  background: #00FF00;
                }
                &.gray2{
                  background: gray;
                }
                &.p_em{
                  max-width: 100px;
                  word-break: break-all;
                }
              }
            }
            td.spacer_td{
              width: 10px;
              border-left: 1px;
              border-left-style: solid;
              border-left-color: #e8e8e8;
            }
            td.name_ {
              background-color: #f5f6fa !important;
          }
            td.name.header_level {
              background-color: #e8e8e8 !important;
            }
          }
          &.mobile{

            margin: auto;
            width: 100%;
            border-collapse: separate;
            border-spacing: 0px;
            tr{
              text-align: center;
              td:not(.spacer_td){
                // border-left: 1px solid black;
                // border-top: 1px solid black;
                width: 25%;
                &.large{
                  width: 25%
                }
                &.name{
                  width: calc(50% - 10px);
                }
              }
            }
          }
        }
        &.no_scroll{
          overflow: unset;
        }
      }
      .loading{
        position: relative;
        width: 100%;
        height: 100%;
        padding: 15px;
        .loading_img{
          position: relative;
          width: 100%;
          height: 100%;
          img{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            max-width: 50%;
            max-height: 50%;
          }
        }
      }
    }
    .act_export{
      margin: 0 !important;
    }
    .insurance_delegation_format_5 .student td{
      white-space: normal !important;
    }
  }
`





export const getFilePageCount = async (file) => {
  const ext = file.name.split(".").pop().toLowerCase();

  switch (ext) {
    case "pdf":
      return await getPdfPages(file);

    case "pptx":
      return await getPptxSlides(file);

    case "xlsx":
    case "xls":
      return await getExcelSheets(file);

    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
    case "bmp":
      return 1;

    case "doc":
    case "docx":
      // Impossible to determine accurately in JavaScript
      return await getDocxPages(file) || 1;

    default:
      return 1;
  }
}

const getPdfPages = async (file) => {
  const bytes = await file.arrayBuffer();
  const pdf = await PDFDocument.load(bytes);
  return pdf.getPageCount();
}

const getPptxSlides = async (file) => {
  const buffer = await file.arrayBuffer();
  const zip = await JSZip.loadAsync(buffer);

  return Object.keys(zip.files).filter((name) =>
    /^ppt\/slides\/slide\d+\.xml$/.test(name)
  ).length;
}

const getExcelSheets = async (file) => {
  const workbook = new ExcelJS.Workbook();

  const buffer = await file.arrayBuffer();

  await workbook.xlsx.load(buffer);

  return workbook.worksheets.length;
}
const getDocxPages = async (file) => {
  const buffer = await file.arrayBuffer();
  const zip = await JSZip.loadAsync(buffer);
  const appXmlFile = zip.file("docProps/app.xml");
  if (!appXmlFile) return 1;

  const appXml = await appXmlFile.async("string");
  const match = appXml.match(/<Pages>(\d+)<\/Pages>/);
  return match ? parseInt(match[1], 10) : 1;
};

// Icône Chèque / Carte
export const CheckIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <path d="M14 14h4" />
    <path d="M16 12l2 2" />
  </svg>
);

// Icône Pièces / Encaissements
export const CoinsIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2c-4.97 0-9 1.79-9 4s4.03 4 9 4 9-1.79 9-4-4.03-4-9-4z" />
    <path d="M3 6v4c0 2.21 4.03 4 9 4s9-1.79 9-4V6" />
    <path d="M3 10v4c0 2.21 4.03 4 9 4s9-1.79 9-4v-4" />
    <path d="M3 14v4c0 2.21 4.03 4 9 4s9-1.79 9-4v-4" />
  </svg>
);

// Icône Calculatrice / Total
export const CalculatorIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="16" y1="14" x2="16" y2="14.01" />
    <line x1="12" y1="14" x2="12" y2="14.01" />
    <line x1="8" y1="14" x2="8" y2="14.01" />
    <line x1="16" y1="18" x2="16" y2="18.01" />
    <line x1="12" y1="18" x2="12" y2="18.01" />
    <line x1="8" y1="18" x2="8" y2="18.01" />
    <line x1="8" y1="10" x2="8" y2="10.01" />
    <line x1="12" y1="10" x2="12" y2="10.01" />
    <line x1="16" y1="10" x2="16" y2="10.01" />
  </svg>
);
